<template>
    <div v-if="pageDevice != null && isLoginUserPageItemWritable">

        <deviceTabs v-if="isLoginUserPageItemReadable" :current="'serial'" :pageDevice="pageDevice" :pageUser="pageUser">
        </deviceTabs>

        <div :class="(isLoginUserPageItemWritable)? 'writable':'notWritable'">

            <div v-if="isLoginUserPageItemWritable">
                <b-alert class="m-0 mt-2 mb-2 p-1 pl-2 fontSizeDot9" show variant="danger" v-if="pageDevice.disabled">
                정지 중이므로 기기의 정보를 변경할 수 없습니다.
                </b-alert>
            </div>

            <b-alert class="m-0 mt-2 mb-0 p-1 pl-2 fontSizeDot8" show variant="danger" v-if="deviceInfoJson != null && !isSameMacAddress && !isSameAcode">
                <div>
                    <b>주의! 연결된 기기가 현 페이지 기기가 아닙니다</b>(연결된 기기 MAC주소: {{deviceInfoJson.ma}}, 현 페이지 기기 MAC주소: {{pageDevice.macAddress}})
                </div>
                    <div class="mt-1" v-if="deviceDid != ''">
                        <router-link :to="{ name: 'tinkDevice', params: { did: deviceDid }, query: { mode: 'serial'}}" custom v-slot="{ navigate }">
                            <b-button @click="navigate" @keypress.enter="navigate" size="sm" variant="danger" class="fontSizeDot8 p-dot1 pl-1 pr-1" role="link">
                                연결된 기기의 페이지로 이동하기
                            </b-button>
                        </router-link>
                    </div>                
            </b-alert>

            <b-alert class="m-0 mt-2 mb-0 p-1 pl-2 fontSizeDot8" show variant="danger" v-if="deviceInfoJson != null && isSameMacAddress && deviceInfoJson.ac != '' && deviceInfoJson.ac != '' &&deviceInfoJson.ac != pageDevice.acode">
                <div>
                    <b>주의! 연결된 기기의 접속코드가 서버의 접속코드와 다릅니다</b>. 서버에서 기기를 삭제하고 다시 등록한 다음에는 실제 기기를 초기화해야 합니다.
                </div>
                <div class="mt-1" v-if="serial != ''">
                    <b-button @click="sendCommand('resetSystem')" size="sm" variant="danger" class="fontSizeDot8 p-dot1 pl-1 pr-1">
                            연결된 기기 초기화하기
                    </b-button>
                </div>                
            </b-alert>

            <p class="mt-2 gothic fontSizeDot9" v-if="serialPort == null">
                팅커블 IoT 키트를 현재 컴퓨터와 USB 케이블로 연결한 다음에 <b-button size="sm" variant="danger" class="pl-2 pr2 fontSizeDot8 pt-dot1 pb-dot1" @click="connectSerialPort">연결하기</b-button> 버튼을 눌러 표시된 USB 목록에 표시된 USB 포트를 선택한 다음에 연결을 눌러주시기 바랍니다. USB 목록에 USB 포트가 보이지 않으면 <a href="https://sparks.gogo.co.nz/assets/_site_/downloads/CH34x_Install_Windows_v3_4.zip"><b-button size="sm" variant="primary" class="pl-2 pr2 fontSizeDot8 pt-dot1 pb-dot1">CH340 드라이버를 다운로드</b-button></a>하여 <b>1. 압축을 푼</b> 다음 <b>2. 파일을 실행</b>한 후 <b>3. INSTALL</b>을 누르세요. 마지막으로 <b>4. USB 케이블을 뽑았다가 다시 꽂으면</b> 됩니다.
            </p>    

            <b-input-group size="sm" class="mt-2">

                <b-form-input v-touch:swipe.stop readonly disabled v-model="connectedSerialInfo" class="fontSizeDot8"/>

                <b-form-input :disabled="serialPort != null" v-touch:swipe.stop v-model="serialBaudRate" class="fontSizeDot8" placeholder="전송속도 자동" :style="`max-width : ${(serialPort == null)? '7':'5'}rem !important`"/>

                <b-button v-if="serialPort == null" variant="secondary" class="pl-2 pr2 fontSizeDot8" slot="append" @click="toggleUseSerialPortFilter" v-b-tooltip.hover.top title="필터 사용이면 팅커블 IoT 키트와 연결된 시리얼 포트만 목록에 표시됩니다.">
                    필터 {{ useSerialPortFilter? "사용" : "사용안함"}}
                </b-button>

                <b-button v-if="serialPort == null" variant="danger" class="pl-2 pr2 fontSizeDot8" slot="append" @click="connectSerialPort">연결하기</b-button>
                <b-button v-else variant="danger" class="pl-2 pr2 fontSizeDot8" slot="append" @click="disconnectSerialPort">연결끊기</b-button>
            </b-input-group>

            <b-input-group size="sm" class="mt-1" v-if="serialPort != null">
                <b-input-group-text slot="prepend" class="leftCellTitleVeryTiny">
                    <label style="margin-bottom : 0rem" class="fontSizeDot8">연결 기기</label>
                </b-input-group-text>
                <b-button size="sm" class="fontSizeDot8 pl-2 pr-2 rounded-0" variant="primary" @click="sendInfo" :disabled="sendCommandDisabled">
                    정보 보기
                </b-button>
                <b-button size="sm" class="fontSizeDot8 pl-2 pr-2 rounded-0" variant="primary" @click="sendReboot" :disabled="sendCommandDisabled">
                    껐다 켜기
                </b-button>
                <b-button v-if="this.deviceInfoJson != null && this.deviceInfoJson.ve < 197 && this.deviceInfoJson.co == 1 && this.deviceInfoJson.op == 0" size="sm" class="fontSizeDot8 pl-2 pr-2 rounded-0" variant="warning" @click="sendCommand('OTA')" :disabled="sendCommandDisabled">
                    기기 업그레이드 하기
                </b-button>
                <b-button size="sm" class="fontSizeDot8 pl-2 pr-2 rounded-0" variant="danger" @click="sendCommand('resetSystem')" :disabled="sendCommandDisabled">
                    초기화 하기
                </b-button>
                <b-button size="sm" class="fontSizeDot8 pl-2 pr-2 rounded-0" variant="secondary" @click="showConfigDeviceWifiFloat" :disabled="deviceInfoJson == null || sendCommandDisabled">
                    WiFi 설정하기
                </b-button>
                <b-button size="sm" class="fontSizeDot8 pl-2 pr-2 rounded-0" variant="secondary" @click="showConfigDeviceConfigFloat" :disabled="deviceInfoJson == null || sendCommandDisabled">
                    기기 설정하기
                </b-button>
                <b-button size="sm" class="fontSizeDot8 pl-2 pr-2 rounded-0" variant="secondary" @click="showConfigDeviceSensorsFloat" :disabled="deviceInfoJson == null || sendCommandDisabled">
                    센서 설정하기
                </b-button>
            </b-input-group>    

            <b-input-group size="sm" class="mt-1">
                <b-input-group-text slot="prepend" class="leftCellTitleVeryTiny">
                    <label style="margin-bottom : 0rem" class="fontSizeDot8">명령어 목록</label>
                </b-input-group-text>
                <b-dropdown text="모든 모드" size="sm" variant="primary" menu-class="p-0 ml-0 mr-0 mt-dot2 mb-dot2 fontSizeDot8" toggle-class="fontSizeDot8 rounded-0" boundary="viewport" :disabled="deviceInfoJson == null">
                    <b-dropdown-item @click="selectCommand('info')"><b>info</b>: 연결된 키트의 정보를 출력합니다. </b-dropdown-item>
                    <b-dropdown-item @click="selectCommand('sensorsInfo')"><b>sensorsInfo</b>: 연결된 키트의 센서 정보를 출력합니다. </b-dropdown-item>
                    <b-dropdown-item @click="selectCommand('reboot')"><b>reboot</b>: 키트를 리부팅합니다. </b-dropdown-item>
                    <b-dropdown-item @click="selectCommand('bootLog')"><b>bootLog</b>: 리부팅하고 부팅 로그를 출력합니다. </b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="selectCommand('config')"><b>config</b>: 키트의 설정을 변경합니다. </b-dropdown-item>
                    <b-dropdown-item @click="selectCommand('saveConfig')"><b>saveConfig</b>: 키트의 설정을 파일로 저장합니다. </b-dropdown-item>
                    <b-dropdown-item @click="selectCommand('setWifi')"><b>setWifi</b>: 키트의 SSID를 설정합니다. </b-dropdown-item>
                    <b-dropdown-item @click="selectCommand('addWifi')"><b>addWifi</b>: MultiWifi 설정에 SSID를 추가합니다. </b-dropdown-item>
                    <b-dropdown-item @click="selectCommand('setTime')"><b>setTime</b>: 키트의 RTC 시간을 설정합니다. </b-dropdown-item>
                    <b-dropdown-item @click="selectCommand('resetSystem')"><b>resetSystem</b>: 시스템을 초기화하고 리부팅합니다. </b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="selectCommand('print')"><b>print</b>: 키트에 저장된 파일을 출력합니다. </b-dropdown-item>
                    <b-dropdown-item @click="selectCommand('create')"><b>create</b>: 텍스트 파일을 만듭니다. </b-dropdown-item>
                    <b-dropdown-item @click="selectCommand('remove')"><b>remove</b>: 파일을 삭제합니다. </b-dropdown-item>
                    <b-dropdown-item @click="selectCommand('saveReport')"><b>saveReport</b>: 키트의 상태 보고서를 저장합니다. </b-dropdown-item>
                </b-dropdown>
                <b-dropdown text="센서 모드만" size="sm" variant="primary" menu-class="fontSizeDot8" boundary="viewport" :toggle-class="(['setWifi','addWifi','config','setTime','print','create','remove','addSensor','read','save'].includes(selectedCommand))?'rounded-0 fontSizeDot8':'rounded-right-only fontSizeDot8'"  :disabled="deviceInfoJson == null || deviceInfoJson.op != 0">
                    <b-dropdown-item @click="selectCommand('disconnectWifi')"><b>disconnectWifi</b>: Wifi 연결을 끊습니다. </b-dropdown-item>
                    <b-dropdown-item @click="selectCommand('connectWifi')"><b>connectWifi</b>: Wifi 연결을 시도합니다. </b-dropdown-item>
                    <b-dropdown-item @click="selectCommand('addSensor')"><b>addSensor</b>: 센서를 추가합니다. </b-dropdown-item>
                    <b-dropdown-item @click="selectCommand('saveSensors')"><b>saveSensors</b>: 센서 설정을 파일로 저장합니다. </b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="selectCommand('read')"><b>read</b>: 센서를 읽습니다. </b-dropdown-item>
                    <b-dropdown-item @click="selectCommand('save')"><b>save</b>: 센서 데이터를 저장합니다. </b-dropdown-item>
                    <b-dropdown-item @click="selectCommand('update')"><b>update</b>: 센서 데이터를 서버로 업로드합니다. </b-dropdown-item>
                    <b-dropdown-item @click="selectCommand('recover')"><b>recover</b>: 저장된 데이터를 복구전송합니다. </b-dropdown-item>
                    <b-dropdown-item @click="selectCommand('upReport')"><b>upReport</b>: 서버로 상태 보고서를 업로드합니다. </b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="selectCommand('downConfig')"><b>downConfig</b>: 설정을 다운로드합니다. </b-dropdown-item>
                    <b-dropdown-item @click="selectCommand('downSensors')"><b>downSensors</b>: 센서설정을 다운로드합니다. </b-dropdown-item>
                    <b-dropdown-item @click="selectCommand('downWifi')"><b>downWifi</b>: WIFI설정을 다운로드합니다. </b-dropdown-item>
                    <b-dropdown-item @click="selectCommand('upConfig')"><b>upConfig</b>: 설정을 업로드합니다. </b-dropdown-item>
                    <b-dropdown-item @click="selectCommand('upWifi')"><b>upWifi</b>: WIFI설정을 업로드합니다. </b-dropdown-item>
                    <b-dropdown-item @click="selectCommand('upSensors')"><b>upSensors</b>: 센서 설정을 업로드합니다.</b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="selectCommand('format')"><b>format</b>: SD 영역을 포맷합니다. </b-dropdown-item>
                    <b-dropdown-item @click="selectCommand('PARAM')"><b>PARAM</b>: ParamsServer를 실행합니다. </b-dropdown-item>
                    <b-dropdown-item @click="selectCommand('OTA')"><b>OTA</b>: Core를 업그레이드합니다. </b-dropdown-item>
                    <!--b-dropdown-item @click="selectCommand('WPS')"><b>WPS</b>: 공유기를 검색합니다. </b-dropdown-item-->
                </b-dropdown>


                <b-dropdown v-if="selectedCommand=='config'" :text="selectedConfigAttrName" size="sm" variant="secondary" menu-class="fontSizeDot8" toggle-class="rounded-0 fontSizeDot8" v-b-tooltip.hover.bottom :title="selectedConfigAttrText">
                    <b-dropdown-item @click="selectConfigAttr(item.name, item.text, item.valueRule)" v-for="(item, index) in configList" :key="index">{{item.text}}</b-dropdown-item>
                </b-dropdown>
                <b-form-input v-if="selectedCommand=='config'" placeholder="속성 값" class="rounded-0 fontSizeDot8" v-model="selectedConfigAttrValue" v-b-tooltip.hover.bottom :title="selectedConfigAttrValueRule"></b-form-input>

                <b-form-input v-if="['setWifi', 'addWifi'].includes(selectedCommand)" class="rounded-0 fontSizeDot8" v-model="selectedCommandOperandSSID" placeholder="WiFi이름(SSID)" v-b-tooltip.hover.bottom title="SSID는 최대 32글자입니다. 영문, 숫자, _만 사용할 수 있으며 한글, 공백, 특수문자는 안됩니다."></b-form-input>
                <b-form-input v-if="['setWifi', 'addWifi'].includes(selectedCommand)" class="rounded-0 fontSizeDot8" v-model="selectedCommandOperandPassword" placeholder="패스워드" v-b-tooltip.hover.bottom title="패스워드는 최대 32글자입니다. 영문, 숫자, _만 사용할 수 있으며 한글, 공백, 특수문자는 안됩니다."></b-form-input>

                <b-form-input v-if="selectedCommand=='setTime'" class="rounded-0 fontSizeDot8" v-model="selectedCommandOperandTime" placeholder="시간 YYYY-MM-DD HH:MM:SS 형식" v-b-tooltip.hover.bottom title="시간입니다. YYYY-MM-DD HH:MM:SS 형식입니다. 예를 들어 2007-06-16 09:01:07과 같이 지정해야 합니다."></b-form-input>

                <b-form-input v-if="['print', 'create', 'remove'].includes(selectedCommand)" class="rounded-0 fontSizeDot8" v-model="selectedCommandOperandFilePath" placeholder="파일 경로" v-b-tooltip.hover.bottom title="파일의 경로 /로 시작합니다. 예를 들어 설정 파일은 /config.json, 멀티 WIFI 설정 파일은 /wifi.json, 센서 설정 파일은 /sensors.json입니다. 상태 보고서는 /re/status.txt입니다. remove 명령의 경우 파일 경로를 지정하지 않으면 모든 설정 파일과 복구 폴더를 삭제합니다."></b-form-input>

                <b-form-input v-if="selectedCommand == 'create'" class="rounded-0 fontSizeDot8" v-model="selectedCommandOperandFileContent" placeholder="파일 내용" v-b-tooltip.hover.bottom title="새로 만들 파일의 내용입니다. 이미 있는 파일의 경우 기존의 내용을 덮어씁니다."></b-form-input>

                <b-form-input v-if="['addSensor', 'read', 'save'].includes(selectedCommand)" class="rounded-0 fontSizeDot8" v-model="selectedCommandOperandSensorName" placeholder="센서 이름" v-b-tooltip.hover.bottom title="센서의 이름입니다. 영문, 숫자, _만 사용할 수 있으며 최대 8글자입니다."></b-form-input>

                <b-dropdown v-if="selectedCommand=='addSensor'" :text="selectedCommandOperandSensorTypeText" size="sm" variant="secondary" menu-class="fontSizeDot8" toggle-class="rounded-0 fontSizeDot8" v-b-tooltip.hover.bottom :title="selectedCommandOperandSensorTypeDesc" boundary="viewport">
                    <b-dropdown-item @click="selectSensorType(item.name, item.value, item.desc)" v-for="(item, index) in sensorTypeList" :key="index">{{item.name}} ({{item.desc}})</b-dropdown-item>
                </b-dropdown>

                <!--b-form-input v-if="selectedCommand == 'addSensor'" class="rounded-0 fontSizeDot8" v-model="selectedCommandOperandSensorReadInterval" placeholder="읽기 간격" :number="true" type="number" min="0" v-b-tooltip.hover.bottom title="센서의 읽기 간격입니다. 단위는 1/1000초입니다. 지정하지 않으면 기본값을 사용합니다."></b-form-input>

                <b-form-input v-if="selectedCommand == 'addSensor'" class="rounded-0 fontSizeDot8" v-model="selectedCommandOperandSensorUpdateInterval" placeholder="업데이트 간격" :number="true" type="number" min="0" v-b-tooltip.hover.bottom title="센서의 업데이트 간격입니다. 단위는 1/1000초입니다. 지정하지 않으면 기본값을 사용합니다."></b-form-input>

                <b-form-input v-if="selectedCommand == 'addSensor'" class="rounded-0 fontSizeDot8" v-model="selectedCommandOperandSensorOpt1" placeholder="옵션1" v-b-tooltip.hover.bottom title="디지털/아날로그 센서는 핀 이름, I2C 센서는 센서의 주소, 시리얼 통신 센서는 RX핀 이름을 지정합니다. 지정하지 않으면 기본값을 사용합니다."></b-form-input>

                <b-form-input v-if="selectedCommand == 'addSensor'" class="rounded-0 fontSizeDot8" v-model="selectedCommandOperandSensorOpt2" placeholder="옵션2" v-b-tooltip.hover.bottom title="시리얼 통신 센서의 TX핀 이름을 지정합니다. 지정하지 않으면 기본값을 사용합니다."></b-form-input-->

                <b-button slot="append" @click="makeContentToWrite" size="sm" class="fontSizeDot8 rounded-right-only pl-2 pr-2" v-b-tooltip.hover title="보낼 내용을 만듭니다." v-if="['setWifi','addWifi','config','setTime','print','create','remove','addSensor','read','save'].includes(selectedCommand)" :disabled="!((selectedCommand=='config' && selectedConfigAttrName!='속성 이름')||(['setWifi','addWifi'].includes(selectedCommand) && selectedCommandOperandSSID!='')||(selectedCommand == 'print' && selectedCommandOperandFilePath!='')||(selectedCommand == 'addSensor' && selectedCommandOperandSensorName!='' &&selectedCommandOperandSensorType!='')||(selectedCommand == 'create' && selectedCommandOperandFilePath !='' && selectedCommandOperandFileContent==''))" :variant="!((selectedCommand=='config' && selectedConfigAttrName!='속성 이름')||(['setWifi','addWifi'].includes(selectedCommand) && selectedCommandOperandSSID!='')||(selectedCommand == 'print' && selectedCommandOperandFilePath!='')||(selectedCommand == 'addSensor' && selectedCommandOperandSensorName!='' &&selectedCommandOperandSensorType!='')||(selectedCommand == 'create' && selectedCommandOperandFilePath !='' && selectedCommandOperandFileContent==''))? 'primary' : 'danger'"> 
                    만들기
                </b-button>
            </b-input-group>
            <b-input-group size="sm" class="mt-1">
                <b-input-group-text slot="prepend" class="leftCellTitleVeryTiny">
                    <label style="margin-bottom : 0rem">보낼 내용</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop v-model="contentToWrite" :disabled="serialPort==null && contentToWrite==''" @keyup.enter="writeToSerial"/>
                <b-button :variant="(serialPort!=null && contentToWrite!='')? 'danger' : 'primary'"  class="fontSizeDot8 rounded-right-only pl-2 pr-2" slot="append" :disabled="serialPort == null || contentToWrite ==''" @click="writeToSerial" id="sendButton">보내기</b-button>
            </b-input-group>


            <b-button-group size="sm" class="mt-3">
                <b-button @click="toggleConsoleAutoScroll" size="sm" class="fontSizeDot8 pl-2 pr-2" :variant="consoleAutoScroll? 'primary' : 'secondary'" v-b-tooltip.hover.bottom title="켜짐이면 새로운 데이터를 읽으면 자동으로 맨 아래까지 스크롤합니다.">
                    스크롤 {{ consoleAutoScroll? "켜짐" : "꺼짐" }}
                </b-button>
                <b-button @click="enlargeConsoleHeight" size="sm" class="fontSizeDot8 pl-2 pr-2" variant="secondary" v-b-tooltip.hover.bottom title="데이터 콘솔 창의 높이를 100픽셀 크게 합니다.">
                    +
                </b-button>
                <b-button @click="reduceConsoleHeight" size="sm" class="fontSizeDot8 pl-2 pr-2" variant="secondary" v-b-tooltip.hover.bottom title="데이터 콘솔 창의 높이를 100픽셀 작게 합니다." :disabled="consoleRowHeight <= 200">
                    -
                </b-button>
                <b-button @click="copyConsole" slot="append" size="sm" class="fontSizeDot8 pl-2 pr-2" variant="secondary" v-b-tooltip.hover.bottom title="내용을 클립보드로 복사합니다.">
                    복사
                </b-button>
                <b-button @click="clearConsole" slot="append" size="sm" class="fontSizeDot8 pl-2 pr-2" variant="secondary" v-b-tooltip.hover.bottom title="데이터 콘솔 창을 지웁니다.">
                    지우기
                </b-button>
            </b-button-group>

            <div class="mt-1 border fontSizeDot8 gothic" :style="`height : ${consoleRowHeight}px; overflow: auto; white-space: pre;}`" ref="consoleContent" v-html="consoleContent">
            </div>
        </div>

        <b-modal v-touch:swipe.stop size="lg" id="setWifiAction"
        tabindex="-1" title="[3/3] WiFi 설정하기" static header-bg-variant="success" header-text-variant="light" footer-bg-variant="light" header-class="pt-2 pb-2 pr-3 mb-1" body-class="pt-1" footer-class="pt-1 pb-1 pr-3 pl-3" content-class="border-0" button-size="sm" data-nextfocus="addDeviceDeviceName" no-close-on-backdrop no-close-on-esc no-stacking hide-footer v-model="showSetWifiAction">

            <div v-if="pageBinded && !pageDevice.disabled && isLoginUserPageItemWritable" class="pb-3">

                <div v-if="deviceInfoJson == null || deviceInfoJson.co != 1">

                    <p v-if="serialPort == null" class="m-0 mt-1 mr-2 gothic fontSize1" style="line-height: 160%;">
                        팅커블 IoT 키트와 현재 컴퓨터를 USB 케이블로 연결한 다음에 연결하기 버튼을 눌러서 USB 포트를 선택하세요.
                    </p> 
                    <p v-else class="m-0 mt-1 mr-2 gothic fontSize1" style="line-height: 160%;">
                        팅커블 IoT 키트와 현재 컴퓨터가 시리얼로 연결되었습니다.
                    </p> 
                    
                    <b-input-group size="md" class="mt-2">

                        <b-form-input v-touch:swipe.stop readonly disabled v-model="connectedSerialInfo" class="p-3 font-weight-bold border-success-dark bg-success-lighter"/>

                        <b-button v-if="serialPort == null" variant="success" class="pl-2 pr2" slot="append" @click="connectSerialPort">연결하기</b-button>

                        <b-button v-else variant="secondary" class="pl-2 pr2" slot="append" @click="disconnectSerialPort">연결끊기</b-button>

                    </b-input-group>

                    <p v-if="serialPort == null" class="m-0 mt-2 mr-2 gothic fontSize1" style="line-height: 160%;">
                        목록에 USB 포트가 보이지 않으면 USB 케이블을 뽑았다가 다시 꽂아주세요. 그래도 없으면 
                        <a href="https://sparks.gogo.co.nz/assets/_site_/downloads/CH34x_Install_Windows_v3_4.zip"><b-button size="md" variant="success" class="pl-1 pr-1 fontSize1 pt-dot1 pb-dot1">CH340 드라이버를 다운로드</b-button></a>하여 <b>1. 압축을 푼</b> 다음 <b>2. 파일을 실행</b>한 후 <b>3. INSTALL</b>을 누르세요. 마지막으로 <b>4. USB 케이블을 뽑았다가 다시 꽂으면</b> 됩니다.
                    </p> 
                    <div v-else-if="deviceInfoJson == null" class="m-0 mt-3 mr-2 gothic fontSize1" style="line-height: 160%;">
                        <p>
                            기기 정보를 가져오는 중입니다. 1분 이상 계속 이 화면이면 기기 정보 가져오기를 눌러주세요.
                        </p>
                        <div class="mt-2">
                            <b-button variant="success" class="pl-2 pr-2" @click="sendInfo">기기 정보 가져오기</b-button>
                        </div>    
                    </div> 
                    <div v-else class="mt-3">
                        <p class="m-0 mt-1 mr-2 gothic fontSize1" style="line-height: 160%;">
                        사용할 WiFi의 이름(SSID)와 비밀번호를 입력한 후에 WiFi 설정하기를 누르세요.
                        </p> 
                        <b-input-group size="md" class="mt-1">
                            <b-input-group-text slot="prepend" class="leftCellTitle text-success-dark border-success-dark bg-success-lighter">
                                <label style="margin-bottom : 0rem" class="m-0 p-0">WiFi 이름 (SSID)</label>
                            </b-input-group-text>
                            <b-form-input v-touch:swipe.stop v-model="deviceInfoJsonSSID" class="p-3 font-weight-bold border-success-dark bg-success-lighter" spellcheck="false"/>
                        </b-input-group>    
                        <b-input-group size="md" class="mt-1">
                            <b-input-group-text slot="prepend" class="leftCellTitle text-success-dark border-success-dark bg-success-lighter">
                                <label style="margin-bottom : 0rem" class="m-0 p-0">WiFi 비밀번호</label>
                            </b-input-group-text>
                            <b-form-input v-touch:swipe.stop v-model="deviceInfoJsonPassword" class="p-3 font-weight-bold border-success-dark bg-success-lighter" spellcheck="false"/>
                        </b-input-group>
                        <div class="mt-2">
                            <b-button variant="success" class="pl-2 pr-2" :disabled="deviceInfoJsonSSID.length < 2" @click="sendSetWifi">WiFi 설정하기</b-button>
                        </div>    
                        <p class="m-0 mt-3 mr-2 gothic fontSize1" style="line-height: 160%;" v-if="this.deviceInfoJson != null && this.deviceInfoJson.ss != ''">
                        WiFi를 설정했으면 팅커블 IoT 키트를 껐다 켜서 WiFi에 연결되는 지 확인하세요. 버튼을 누른 후에 기기가 껐다 완전히 켜질 때까지 기다리기 바랍니다.
                        </p> 
                        <div class="mt-2">
                            <b-button variant="danger" class="pl-2 pr-2" v-if="this.deviceInfoJson != null && this.deviceInfoJson.ss != ''" @click="sendReboot"  :disabled="!setWifiFinished">기기 껐다 켜기</b-button>
                        </div>    
                    </div>    
                </div>    
                <div v-else-if="deviceInfoJson != null && deviceInfoJson.ac != '' && deviceInfoJson.ac != '' && deviceInfoJson.ac != pageDevice.acode" class="m-0 mt-3 mr-2 gothic fontSize1" style="line-height: 160%;">
                    <p>
                        연결된 기기의 접속코드가 서버의 접속코드와 다릅니다. 서버에서 기기를 삭제하고 다시 등록한 경우에는 실제 기기를 초기화해야 합니다.
                        기기 초기화를 한 다음에 기기가 껐다 완전히 켜질 때까지 기다리기 바랍니다.
                    </p>
                    <div class="mt-2">
                        <b-button variant="danger" class="pl-2 pr-2" @click="sendCommand('resetSystem')">기기 초기화 하기</b-button>
                    </div>    
                </div> 
                <div v-else>
                    <h3 class="text-success-dark text-center pt-2 pb-2">기기 등록 및 설정 완료 !!!</h3>
                    <p class="m-0 mt-1 mr-2 gothic fontSize1" style="line-height: 160%;">
                        팅커블 IoT 키트가 WiFi에 연결되었습니다. 다른 곳에서 기기를 사용하는 경우 미리 연결할 WiFi 이름과 비밀번호를 모두 등록해두시면 편리합니다.
                    </p> 
                    <p v-if="deviceWifiJsonMerged != null && deviceWifiJson.length != 0" class="mt-1 text-success-dark border-success-dark bg-success-lighter gothic p-1 pl-2 pr-2 fontSizeDot9">
                        기본 WiFi 이름 : {{ deviceInfoJson.ss }}, 추가 등록한 WiFi 목록 : {{ Object.keys(this.deviceWifiJsonMerged).join(', ') }}
                    </p>    
                    <div>
                        <b-input-group size="md" class="mt-1">
                            <b-input-group-text slot="prepend" class="leftCellTitle text-success-dark border-success-dark bg-success-lighter">
                                <label style="margin-bottom : 0rem" class="m-0 p-0">추가할 WiFi 이름</label>
                            </b-input-group-text>
                            <b-form-input v-touch:swipe.stop v-model="deviceWifiJsonNewSSID" trim class="p-3 font-weight-bold border-success-dark bg-success-lighter" spellcheck="false" maxlength="32" minlength="1" size="md" pattern='^[^!#;+\]\/"\t][^+\]\/"\t]{0,30}[^ !#;+\]\/"\t]$|^[^ !#;+\]\/"\t]$' v-b-tooltip.focus :title="(deviceWifiJsonMerged == null || Object.keys(deviceWifiJsonMerged).includes(deviceWifiJsonNewSSID))? 'WiFi 정보를 못가져왔거나 동일한 이름의 SSID가 이미 등록되어 있습니다.':'연결할 Wifi의 이름(SSID). 32글자까지 가능. 영문 대소문자, 숫자, _, - 등 일부 기호만 사용 가능하며, 한글, 공백문자, ?, $, [, \, ], +는 사용할 수 없습니다.'"/>
                        </b-input-group>    
                        <b-input-group size="md" class="mt-1">
                            <b-input-group-text slot="prepend" class="leftCellTitle text-success-dark border-success-dark bg-success-lighter">
                                <label style="margin-bottom : 0rem" class="m-0 p-0">추가할 WiFi 비밀번호</label>
                            </b-input-group-text>
                            <b-form-input v-touch:swipe.stop v-model="deviceWifiJsonNewPassword" trim class="p-3 font-weight-bold border-success-dark bg-success-lighter" spellcheck="false" size="md" maxlength="32" minlength="1" v-b-tooltip.focus title="연결할 Wifi의 패스워드. 32글자까지 가능."/>
                        </b-input-group>
                    </div>
                    
                    <div class="mt-2 text-right">
                        <b-button variant="success" class="pl-2 pr-2 pt-dot2 pb-dot2" @click="sendAddWifi" :disabled="deviceWifiJsonNewSSID == '' || deviceWifiJsonMerged == null || Object.keys(deviceWifiJsonMerged).includes(deviceWifiJsonNewSSID)">
                            {{isSameMacAddress? 'WiFi 이름과 비밀번호 모두 추가하기' : 'WiFi 이름과 비밀번호 연결된 기기에 적용하기'}}
                        </b-button>
                    </div>

                    <p class="m-0 mt-4 mr-2 gothic fontSize1" style="line-height: 160%;">
                        이제 추가로 다음과 같은 작업을 할 수 있습니다.
                    </p> 
                    <ul class="m-0 mt-1 mr-2 gothic fontSizeDot9" style="line-height: 160%;">
                        <li class="mb-1">
                            <span>센서보기:</span>
                            <router-link :to="{ name: 'tinkSensor', params: { sid: value.id } }" custom v-slot="{ navigate }" style="vertical-align: 0px;" v-for="(value, name) in pageDevice.sensors" :key="name">
                            <b-button variant="secondary" size="sm" @click="navigate" @keypress.enter="navigate" role="link" class="m-1 mt-dot1 mb-dot1 pt-dot1 pb-dot1 fontSizeDot8">
                                {{name}}
                                ({{value.title}})
                                센서
                            </b-button>
                            </router-link>
                            에서 측정한 데이터를 확인할 수 있습니다.
                        </li>
                        <li class="mb-1">
                            <router-link style="vertical-align: 0px;" :to="{ name: 'tinkDevice', params: { did: pageDevice.id }, query: { mode : 'intro'} }" custom v-slot="{ navigate }">
                                <b-button variant="success" size="sm" @click="navigate" @keypress.enter="navigate" role="link" class="m-dot1 pt-dot1 pb-dot1 fontSizeDot8">
                                    기본설정
                                </b-button>
                            </router-link>
                            : 기기 위치, 공개 여부, 추가 관리자에 대한 추가 설정을 할 수 있습니다.
                        </li>
                        <li class="mb-1">
                            <router-link style="vertical-align: 0px;" :to="{ name: 'tinkDevice', params: { did: pageDevice.id }, query: { mode : 'config'} }" custom v-slot="{ navigate }">
                                <b-button variant="success" size="sm" @click="navigate" @keypress.enter="navigate" role="link" class="m-dot1 pb-dot1 fontSizeDot8">
                                    기기설정
                                </b-button>
                            </router-link>
                            : 기기의 동작에 대한 상세한 설정을 할 수 있습니다.
                        </li>
                        <li class="mb-1">
                            <router-link style="vertical-align: 0px;" :to="{ name: 'tinkDevice', params: { did: pageDevice.id }, query: { mode : 'sensors'} }" custom v-slot="{ navigate }">
                                <b-button variant="success" size="sm" @click="navigate" @keypress.enter="navigate" role="link" class="m-dot1 pb-dot1 fontSizeDot8">
                                    센서설정
                                </b-button>
                            </router-link>
                            : 센서에 대한 상세한 설정을 할 수 있습니다.
                        </li>
                        <li class="mb-1">
                            <b-button variant="success" size="sm" @click="clearActionAndHideModal" @keypress.enter="navigate" role="link" class="m-dot1 pt-dot1 pb-dot1 fontSizeDot8">
                                시리얼통신
                            </b-button>
                            : 기기와 직접 통신하면서 다양한 설정과 모니터링을 할 수 있습니다.
                        </li>
                        <li class="mb-1">
                            기타:
                            <router-link style="vertical-align: 0px;" :to="{ name: 'tinkDevice', params: { did: pageDevice.id }, query: { mode : 'log'} }" custom v-slot="{ navigate }">
                                <b-button variant="success" size="sm" @click="navigate" @keypress.enter="navigate" role="link" class="m-dot1 pt-dot1 pb-dot1 fontSizeDot8">
                                    로그목록
                                </b-button>
                            </router-link>,<router-link style="vertical-align: 0px;" :to="{ name: 'tinkDevice', params: { did: pageDevice.id }, query: { mode : 'report'} }" custom v-slot="{ navigate }">
                                <b-button variant="success" size="sm" @click="navigate" @keypress.enter="navigate" role="link" class="m-dot1 pt-dot1 pb-dot1 fontSizeDot8">
                                    보고서
                                </b-button>
                            </router-link>에서 기기와 관련된 추가 정보를 확인할 수 있습니다.
                        </li>
                    </ul>
                </div>    


            </div>
        </b-modal>


        <b-modal v-touch:swipe.stop size="lg" id="deviceInfoFloat"
        tabindex="-1" title="연결된 기기 정보" static header-bg-variant="primary" header-text-variant="light" footer-bg-variant="light" footer-text-variant="primary" header-class="pt-2 pb-2 pr-3 pl-3" footer-class="pt-1 pb-1 pr-3 pl-3" content-class="border-0" button-size="sm" data-nextfocus="hideDeviceInfoFloat">

            <div v-if="serialPort != null && deviceInfoJson != null">

                <b-alert class="m-0 mb-2 p-1 pl-2 fontSizeDot8" show variant="danger" v-if="deviceInfoJson != null && !isSameMacAddress && !isSameAcode">
                    <div>
                        <b>주의! 연결된 기기가 현 페이지 기기가 아닙니다</b>(연결된 기기 MAC주소: {{deviceInfoJson.ma}}, 현 페이지 기기 MAC주소: {{pageDevice.macAddress}})
                    </div>
                    <div class="mt-1" v-if="deviceDid != ''">
                        <router-link :to="{ name: 'tinkDevice', params: { did: deviceDid }, query: { mode: 'serial'}}" custom v-slot="{ navigate }">
                            <b-button @click="navigate" @keypress.enter="navigate" size="sm" variant="danger" class="fontSizeDot8 p-dot1 pl-1 pr-1" role="link">
                                연결된 기기의 페이지로 이동하기
                            </b-button>
                        </router-link>
                    </div>                
                </b-alert>

                <b-alert class="m-0 mt-2 mb-0 p-1 pl-2 fontSizeDot8" show variant="danger" v-if="deviceInfoJson != null && isSameMacAddress && deviceInfoJson.ac != '' && deviceInfoJson.ac != '' &&deviceInfoJson.ac != pageDevice.acode">
                    <div>
                        <b>주의! 연결된 기기의 접속코드가 서버의 접속코드와 다릅니다</b>. 서버에서 기기를 삭제하고 다시 등록한 다음에는 기기 초기화가 필요합니다.
                    </div>
                    <div class="mt-1" v-if="serial != ''">
                        <b-button @click="sendCommand('resetSystem')" size="sm" variant="danger" class="fontSizeDot8 p-dot1 pl-1 pr-1">
                                연결된 기기 초기화하기
                        </b-button>
                    </div>                
                </b-alert>

                <b-input-group size="sm" class="mt-3">
                    <b-input-group-text slot="prepend" class="leftCellTitleVeryTiny">
                        <label style="margin-bottom : 0rem" class="fontSizeDot8">코어 버전</label>
                    </b-input-group-text>
                    <b-form-input v-touch:swipe.stop readonly :value="deviceInfoJson.ve/100" class="fontSizeDot8"/>
                    <b-button variant="danger" v-if="deviceInfoJson.ve < 197" class="fontSizeDot8 rounded-right-only" slot="append" @click="sendCommand('OTA');" :disabled="deviceInfoJson.co==0 || deviceInfoJson.op != 0" v-b-tooltip.hover title="연결된 기기에 최신 버전의 코어 프로그램을 설치합니다.">업그레이드</b-button>
                </b-input-group>    
                <b-input-group size="sm" class="mt-1">
                    <b-input-group-text slot="prepend" class="leftCellTitleVeryTiny">
                        <label style="margin-bottom : 0rem" class="fontSizeDot8">설정 버전</label>
                    </b-input-group-text>
                    <b-form-input v-touch:swipe.stop readonly :value="deviceInfoJson.cv" :class="isSameMacAddress && pageDevice.config != null && pageDevice.config.ve != deviceInfoJson.cv? 'fontSizeDot8 font-weight-bold text-danger bg-danger-light':'fontSizeDot8'" v-b-tooltip.hover.top :title="true? '기기 설정하기에서 설정을 동기화하세요.':''"/>

                    <b-input-group-text slot="append" class="text-danger bg-danger-light" v-if="isSameMacAddress && pageDevice.config != null && pageDevice.config.ve != deviceInfoJson.cv">
                        <label style="margin-bottom : 0rem" class="fontSizeDot8 pl-2 pr-2">서버: {{pageDevice.config.ve}}</label>
                    </b-input-group-text>

                    <b-button variant="danger" :disabled="deviceInfoJson.co == 0" class="fontSizeDot8" slot="append" @click="showConfigDeviceConfigFloat" v-if="isSameMacAddress && pageDevice.config != null && pageDevice.config.ve != deviceInfoJson.cv">기기 설정하기</b-button>

                </b-input-group>    
                <b-input-group size="sm" class="mt-1">
                    <b-input-group-text slot="prepend" class="leftCellTitleVeryTiny">
                        <label style="margin-bottom : 0rem" class="fontSizeDot8">접속 코드</label>
                    </b-input-group-text>
                    <b-form-input v-touch:swipe.stop readonly :value="deviceInfoJson.ac == ''? '없음' : deviceInfoJson.ac" class="fontSizeDot8" :class="isSameMacAddress && pageDevice.config != null && pageDevice.config.ac != deviceInfoJson.ac? 'fontSizeDot8 font-weight-bold text-danger bg-danger-light':'fontSizeDot8'" v-b-tooltip.hover.top :title="true? '기기 설정하기에서 설정을 동기화하세요.':''"/>
                    <b-input-group-text slot="append" class="text-danger bg-danger-light" v-if="isSameMacAddress && pageDevice.config != null && pageDevice.config.ac != deviceInfoJson.ac">
                        <label style="margin-bottom : 0rem" class="fontSizeDot8 pl-2 pr-2">서버: {{pageDevice.config.ac}}</label>
                    </b-input-group-text>
                </b-input-group>    
              
                <b-input-group size="sm" class="mt-1">
                    <b-input-group-text slot="prepend" class="leftCellTitleVeryTiny">
                        <label style="margin-bottom : 0rem" class="fontSizeDot8">MAC 주소</label>
                    </b-input-group-text>
                    <b-form-input v-touch:swipe.stop readonly :value="deviceInfoJson.ma" class="fontSizeDot8"/>
                </b-input-group>    
                <b-input-group size="sm" class="mt-1">
                    <b-input-group-text slot="prepend" class="leftCellTitleVeryTiny">
                        <label style="margin-bottom : 0rem" class="fontSizeDot8">표시 모드</label>
                    </b-input-group-text>
                    <b-form-input v-touch:swipe.stop readonly :value="deviceInfoJson.op == 0? '센서 모드 (' + deviceShowMode + ')' : '설정 모드 (' + deviceShowMode + ')'" class="fontSizeDot8"/>
                </b-input-group>    
                <b-input-group size="sm" class="mt-1">
                    <b-input-group-text slot="prepend" class="leftCellTitleVeryTiny">
                        <label style="margin-bottom : 0rem" class="fontSizeDot8">업데이트 간격</label>
                    </b-input-group-text>
                    <b-form-input v-touch:swipe.stop readonly :value="deviceInfoJson.ui" class="fontSizeDot8"/>
                    <b-input-group-text slot="append" style="min-width: 4rem; background-color: white !important;">
                        <label style="margin-bottom : 0rem" class="fontSizeDot8">1/1000 초</label>
                    </b-input-group-text>
                </b-input-group>

                <b-input-group size="sm" class="mt-1">
                    <b-input-group-text slot="prepend" class="leftCellTitleVeryTiny">
                        <label style="margin-bottom : 0rem" class="fontSizeDot8">I2C 센서 목록</label>
                    </b-input-group-text>
                    <b-form-input v-touch:swipe.stop readonly :value="deviceI2CSensors" class="fontSizeDot8"/>
                </b-input-group>

                <b-input-group size="sm" class="mt-1" v-if="deviceInfoJson.ie.length != 0">
                    <b-input-group-text slot="prepend" class="leftCellTitleVeryTiny">
                        <label style="margin-bottom : 0rem" class="fontSizeDot8">I2C 에러</label>
                    </b-input-group-text>
                    <b-form-input v-touch:swipe.stop readonly :value="deviceInfoJson.ie.map(el => '0x'+el.toString(16)).join(', ')" :class="deviceInfoJson.ie.length != 0? 'fontSizeDot8 text-danger bg-danger-light':'fontSizeDot8'" variant="danger" v-b-tooltip.hover.top :title="deviceInfoJson.ie.length != 0? 'I2C 센서에 에러가 있습니다. I2C 센서 목록에 없는 센서를 제거하고 다시 꽂아보시기 바랍니다. 계속 동일한 에러가 발생하면 센서가 고장난 것입니다.':''"/>
                </b-input-group>

                <b-input-group size="sm" class="mt-3">
                    <b-input-group-text slot="prepend" class="leftCellTitleVeryTiny">
                        <label style="margin-bottom : 0rem" class="fontSizeDot8">기기 경과 시간</label>
                    </b-input-group-text>
                    <b-form-input v-touch:swipe.stop readonly :value="deviceInfoJson.ms / 1000" class="fontSizeDot8"/>
                    <b-input-group-text slot="append" style="min-width: 4rem; background-color: white !important;">
                        <label style="margin-bottom : 0rem" class="fontSizeDot8">초</label>
                    </b-input-group-text>
                </b-input-group>
                <b-input-group size="sm" class="mt-1" v-if="deviceInfoJson.rr != 0">
                    <b-input-group-text slot="prepend" class="leftCellTitleVeryTiny">
                        <label style="margin-bottom : 0rem" class="fontSizeDot8">시계 모듈 실행</label>
                    </b-input-group-text>
                    <b-form-input v-touch:swipe.stop readonly :value="deviceInfoJson.rr? '실행중':'실행안됨'" class="fontSizeDot8"/>
                </b-input-group>
                <b-input-group size="sm" class="mt-1" v-if="deviceInfoJson.rr != 0">
                    <b-input-group-text slot="prepend" class="leftCellTitleVeryTiny">
                        <label style="margin-bottom : 0rem" class="fontSizeDot8">시계 모듈 시간</label>
                    </b-input-group-text>
                    <b-form-input v-touch:swipe.stop readonly :value="dateToString(new Date(deviceInfoJson.rt*1000),'-', ' ', ':')" :class="deviceInfoJson.rr < 1609426800? 'fontSizeDot8 font-weight-bold text-danger bg-danger-light':'fontSizeDot8'" v-b-tooltip.hover.top :title="deviceInfoJson.rr < 1609426800? '기기 설정하기에서 NTP 항상 동기화를 사용으로 지정하세요. 그리고, 기기를 껐다 켠 후에 다시 WiFi에 연결하세요.':''"/>
                    <b-button variant="primary" v-if="deviceInfoJson.rr < 1609426800" class="fontSizeDot8" slot="append" @click="showConfigDeviceConfigFloat">기기 설정하기</b-button>
                    <b-button variant="danger" v-if="deviceInfoJson.rr < 1609426800" class="fontSizeDot8 rounded-right-only" slot="append" @click="sendReboot">껐다 켜기</b-button>
                </b-input-group>
                <b-input-group size="sm" class="mt-1" v-if="deviceInfoJson.co == 1 || deviceInfoJson.rr == 1">
                    <b-input-group-text slot="prepend" class="leftCellTitleVeryTiny">
                        <label style="margin-bottom : 0rem" class="fontSizeDot8">기기 시간</label>
                    </b-input-group-text>
                    <b-form-input v-touch:swipe.stop readonly :value="dateToString(new Date(deviceInfoJson.ti*1000),'-', ' ', ':')" :class="deviceInfoJson.ti < 1609426800? 'fontSizeDot8 text-danger bg-danger-light':'fontSizeDot8'" v-b-tooltip.hover.top :title="deviceInfoJson.ti < 1609426800? '기기 설정하기에서 NTP 항상 동기화를 사용으로 지정하세요. 그리고, 기기를 껐다 켠 후에 다시 WiFi에 연결하세요.':''"/>
                    <b-button variant="primary" v-if="deviceInfoJson.ti < 1609426800" class="fontSizeDot8" slot="append" @click="showConfigDeviceConfigFloat">기기 설정하기</b-button>
                    <b-button variant="danger" v-if="deviceInfoJson.ti < 1609426800" class="fontSizeDot8 rounded-right-only" slot="append" @click="sendReboot">껐다 켜기</b-button>
                </b-input-group>
                <b-input-group size="sm" class="mt-1" v-if="deviceInfoJson.co == 1 || deviceInfoJson.rr == 1">
                    <b-input-group-text slot="prepend" class="leftCellTitleVeryTiny">
                        <label style="margin-bottom : 0rem" class="fontSizeDot8">기기 켜진 시각</label>
                    </b-input-group-text>
                    <b-form-input v-touch:swipe.stop readonly :value="dateToString(new Date(deviceInfoJson.bo*1000),'-', ' ', ':')" :class="deviceInfoJson.bo < 1609426800? 'fontSizeDot8 text-danger bg-danger-light':'fontSizeDot8'" v-b-tooltip.hover.top :title="deviceInfoJson.bo < 1609426800? '기기 설정하기에서 NTP 항상 동기화를 사용으로 지정하세요. 그리고, 기기를 껐다 켠 후에 다시 WiFi에 연결하세요.':''"/>
                    <b-button variant="primary" v-if="deviceInfoJson.bo < 1609426800" class="fontSizeDot8" slot="append" @click="showConfigDeviceConfigFloat">기기 설정하기</b-button>
                    <b-button variant="danger" v-if="deviceInfoJson.bo < 1609426800" class="fontSizeDot8 rounded-right-only" slot="append" @click="sendReboot">껐다 켜기</b-button>
                </b-input-group>
                <b-input-group size="sm" class="mt-3">
                    <b-input-group-text slot="prepend" class="leftCellTitleVeryTiny">
                        <label style="margin-bottom : 0rem" class="fontSizeDot8">기기 WiFi</label>
                    </b-input-group-text>
                    <b-form-input v-touch:swipe.stop readonly :value="deviceInfoJson.co? '연결됨':'연결안됨'" :class="deviceInfoJson.co == 0? 'fontSizeDot8 text-danger bg-danger-light font-weight-bold':'fontSizeDot8'" v-b-tooltip.hover.top :title="deviceInfoJson.co == 0? 'WiFi 설정하기에서 기기를 WiFi에 연결하세요.':''"/>
                    <b-button variant="danger" v-if="deviceInfoJson.co == 0" class="fontSizeDot8 rounded-right-only" slot="append" @click="showConfigDeviceWifiFloat">WiFi 설정하기</b-button>
                </b-input-group>
                <b-input-group size="sm" class="mt-1" v-if="deviceInfoJson.co != 0">
                    <b-input-group-text slot="prepend" class="leftCellTitleVeryTiny">
                        <label style="margin-bottom : 0rem" class="fontSizeDot8">기기 IP 주소</label>
                    </b-input-group-text>
                    <b-form-input v-touch:swipe.stop readonly :value="deviceInfoJson.ip" class="fontSizeDot8"/>
                </b-input-group>
                <b-input-group size="sm" class="mt-1" v-if="deviceInfoJson.co != 0">
                    <b-input-group-text slot="prepend" class="leftCellTitleVeryTiny">
                        <label style="margin-bottom : 0rem" class="fontSizeDot8">WiFi 신호세기</label>
                    </b-input-group-text>
                    <b-form-input v-touch:swipe.stop readonly :value="deviceInfoJson.rs" :class="deviceInfoJson.rs < -70? 'fontSizeDot8 text-danger bg-danger-light':'fontSizeDot8'" v-b-tooltip.hover :title="deviceInfoJson.rs < -70? 'WiFi 신호의 세기는 -99에서 35 dBm이며 클수록 신호의 세기가 강합니다. 신호의 세기가 너무 약합니다. 기기를 공유기 가까이 두세요.':'WiFi 신호의 세기는 -99에서 35 dBm이며 클수록 신호의 세기가 강합니다.'"/>
                </b-input-group>
                <b-input-group size="sm" class="mt-1">
                    <b-input-group-text slot="prepend" class="leftCellTitleVeryTiny">
                        <label style="margin-bottom : 0rem" class="fontSizeDot8">WiFi 이름</label>
                    </b-input-group-text>
                    <b-form-input v-touch:swipe.stop readonly :value="deviceInfoJson.ss" class="fontSizeDot8"/>

                </b-input-group>    
                <b-input-group size="sm" class="mt-1">
                    <b-input-group-text slot="prepend" class="leftCellTitleVeryTiny">
                        <label style="margin-bottom : 0rem" class="fontSizeDot8">WiFi 비밀번호</label>
                    </b-input-group-text>
                    <b-form-input v-touch:swipe.stop readonly :value="deviceInfoJson.pw" class="fontSizeDot8"/>
                </b-input-group>    
                <b-input-group size="sm" class="mt-1">
                    <b-input-group-text slot="prepend" class="leftCellTitleVeryTiny">
                        <label style="margin-bottom : 0rem" class="fontSizeDot8">WiFi 연결 횟수</label>
                    </b-input-group-text>
                    <b-form-input v-touch:swipe.stop readonly :value="deviceInfoJson.wc" :class="deviceInfoJson.wc > 5? 'fontSizeDot8 text-danger bg-danger-light':'fontSizeDot8'" v-b-tooltip.hover :title="deviceInfoJson.wc > 5?'기기가 켜진 후에 WiFi 재연결 횟수가 너무 많습니다. 기기를 재부팅하세요.':'기기가 켜진 후에 WiFi에 다시 연결된 횟수로 이 값이 50이 되면 기기가 강제로 리부팅됩니다.'"/>
                    <b-button variant="danger" v-if="deviceInfoJson.wc > 5" class="fontSizeDot8 rounded-right-only" slot="append" @click="sendReboot">껐다 켜기</b-button>
                </b-input-group>    
                <b-input-group size="sm" class="mt-3">
                    <b-input-group-text slot="prepend" class="leftCellTitleVeryTiny">
                        <label style="margin-bottom : 0rem" class="fontSizeDot8">남은 힙 메모리</label>
                    </b-input-group-text>
                    <b-form-input v-touch:swipe.stop readonly :value="deviceInfoJson.he" :class="deviceInfoJson.he < 5000? 'fontSizeDot8 text-danger bg-danger-light':'fontSizeDot8'" v-b-tooltip.hover :title="deviceInfoJson.he < 5000? '남은 힙 메모리가 너무 작습니다. 기기를 꼈다 켜세요. 이 값이 1000보다 작아지면 기기가 강제로 리부팅됩니다.' : '이 값이 1000보다 작아지면 기기가 강제로 리부팅됩니다.'"/>
                    <b-input-group-text slot="append" style="min-width: 4rem; background-color: white !important;">
                        <label style="margin-bottom : 0rem" class="fontSizeDot8">바이트</label>
                    </b-input-group-text>
                    <b-button variant="danger" v-if="deviceInfoJson.he < 5000" class="fontSizeDot8 rounded-right-only" slot="append" @click="sendReboot">껐다 켜기</b-button>
                </b-input-group>
                <b-input-group size="sm" class="mt-1">
                    <b-input-group-text slot="prepend" class="leftCellTitleVeryTiny">
                        <label style="margin-bottom : 0rem" class="fontSizeDot8">남은 연속 스택</label>
                    </b-input-group-text>
                    <b-form-input v-touch:swipe.stop readonly :value="deviceInfoJson.st" :class="deviceInfoJson.st < 400? 'fontSizeDot8 text-danger bg-danger-light':'fontSizeDot8'"  v-b-tooltip.hover :title="deviceInfoJson.st < 400? '남은 연속 스택 공간이 너무 작습니다. 기기를 껐다 켜세요. 이 값이 300보다 작아지면 기기가 강제로 리부팅됩니다.' : '이 값이 300보다 작아지면 기기가 강제로 리부팅됩니다.'"/>
                    <b-input-group-text slot="append" style="min-width: 4rem; background-color: white !important;">
                        <label style="margin-bottom : 0rem" class="fontSizeDot8">바이트</label>
                    </b-input-group-text>
                    <b-button variant="danger" v-if="deviceInfoJson.st < 400" class="fontSizeDot8 rounded-right-only" slot="append" @click="sendReboot">껐다 켜기</b-button>
                </b-input-group>
                <b-input-group size="sm" class="mt-1">
                    <b-input-group-text slot="prepend" class="leftCellTitleVeryTiny">
                        <label style="margin-bottom : 0rem" class="fontSizeDot8">업데이트 에러</label>
                    </b-input-group-text>
                    <b-form-input v-touch:swipe.stop readonly :value="deviceInfoJson.ue" :class="deviceInfoJson.ue > 10? 'fontSizeDot8 text-danger bg-danger-light':'fontSizeDot8'" v-b-tooltip.hover :title="deviceInfoJson.ue > 10? '기기가 켜진 후에 데이터 업데이트 에러가 있습니다. 기기를 껐다 켜세요. 이 값이 100이 되면 기기가 강제로 리부팅됩니다.' : '기기가 켜진 후에 데이터 업데이트 에러 수로 이 값이 100이 되면 기기가 강제로 리부팅됩니다.'"/>
                    <b-button variant="danger" v-if="deviceInfoJson.ue > 10" class="fontSizeDot8 rounded-right-only" slot="append" @click="sendReboot">껐다 켜기</b-button>
                </b-input-group>
                <b-input-group size="sm" class="mt-1">
                    <b-input-group-text slot="prepend" class="leftCellTitleVeryTiny">
                        <label style="margin-bottom : 0rem" class="fontSizeDot8">파일 시스템</label>
                    </b-input-group-text>
                    <b-form-input v-touch:swipe.stop readonly :value="`${deviceInfoJson.fu} 바이트 / 전체 ${deviceInfoJson.ft} 바이트 (${Math.floor(deviceInfoJson.fu/deviceInfoJson.ft*100)}%)`" :class="Math.floor(deviceInfoJson.fu/deviceInfoJson.ft*100) > 50? 'fontSizeDot8 text-danger bg-danger-light':'fontSizeDot8'" v-b-tooltip.hover :title="Math.floor(deviceInfoJson.fu/deviceInfoJson.ft*100) > 50? '파일 시스템이 반 이상 차 있습니다. 복구 파일을 삭제하세요.' : '파일 시스템이 80%가 차게 되면 기기가 리부팅되고 격리된 파일은 자동으로 삭제됩니다.'"/>
                    <b-button variant="danger" v-if="deviceInfoJson.ue > 10" class="fontSizeDot8 rounded-right-only" slot="append" @click="sendReboot">껐다 켜기</b-button>
                </b-input-group>
                <b-input-group size="sm" class="mt-1">
                    <b-input-group-text slot="prepend" class="leftCellTitleVeryTiny">
                        <label style="margin-bottom : 0rem" class="fontSizeDot8">격리된 파일</label>
                    </b-input-group-text>
                    <b-form-input v-touch:swipe.stop readonly :value="deviceInfoJson.os == -1? '없음':deviceInfoJson.os + ' 바이트 / ' + deviceInfoJson.oc + ' 개'" class="fontSizeDot8" v-b-tooltip.hover title="측정 후에 서버로 반영 실패하여 별도로 격리된 파일의 크기와 개수입니다. 이 파일은 설정 모드를 사용하여 다운로드 후에 수동으로 업로드할 수 있습니다."/>
                </b-input-group>
            </div>    

            <template slot="modal-footer">
                <b-button variant="secondary" size="sm" id="hideDeviceInfoFloat" @click="hideModal('deviceInfoFloat')">
                    닫기
                </b-button>
            </template>
        </b-modal>


        <b-modal v-touch:swipe.stop size="lg" id="configDeviceWifiFloat"
        tabindex="-1" title="기기 WiFi 설정하기" static @show="modalShowFocus" data-nextfocus="hideConfigDeviceWifiFloat" header-bg-variant="primary" header-text-variant="light" footer-bg-variant="light" footer-text-variant="primary" header-class="pt-2 pr-3 pl-3" footer-class="pt-1 pb-1 pr-3 pl-3" content-class="border-0" button-size="sm">
            <div v-if="serialPort != null && deviceInfoJson != null">
                
                <b-alert class="m-0 mb-2 p-1 pl-2 fontSizeDot8" show variant="danger" v-if="deviceInfoJson != null && !isSameMacAddress && !isSameAcode">
                    <div>
                        <b>주의! 연결된 기기가 현 페이지 기기가 아닙니다</b>(연결된 기기 MAC주소: {{deviceInfoJson.ma}}, 현 페이지 기기 MAC주소: {{pageDevice.macAddress}})
                    </div>
                    <div class="mt-1" v-if="deviceDid != ''">
                        <router-link :to="{ name: 'tinkDevice', params: { did: deviceDid }, query: { mode: 'serial'}}" custom v-slot="{ navigate }">
                            <b-button @click="navigate" @keypress.enter="navigate" size="sm" variant="danger" class="fontSizeDot8 p-dot1 pl-1 pr-1" role="link">
                                연결된 기기의 페이지로 이동하기
                            </b-button>
                        </router-link>
                    </div>                
                </b-alert>

                <b-alert class="m-0 mt-2 mb-0 p-1 pl-2 fontSizeDot8" show variant="danger" v-if="deviceInfoJson != null && isSameMacAddress && deviceInfoJson.ac != '' && deviceInfoJson.ac != '' &&deviceInfoJson.ac != pageDevice.acode">
                    <div>
                        <b>주의! 연결된 기기의 접속코드가 서버의 접속코드와 다릅니다</b>. 서버에서 기기를 삭제하고 다시 등록한 다음에는 기기 초기화가 필요합니다.
                    </div>
                    <div class="mt-1" v-if="serial != ''">
                        <b-button @click="sendCommand('resetSystem')" size="sm" variant="danger" class="fontSizeDot8 p-dot1 pl-1 pr-1">
                                연결된 기기 초기화하기
                        </b-button>
                    </div>                
                </b-alert>

                <div class="mt-0">
                    <b-button variant="primary" class="fontSizeDot8 pt-dot2 pb-dot2" :disabled="deviceInfoJson.co != 0 || deviceInfoJson.op !=0 || (deviceInfoJson.ss == '' && deviceInfoJson.mw == 0)" @click="sendConnectWifi">
                        기기 WiFi 연결하기
                    </b-button>
                    <b-button variant="primary" class="fontSizeDot8 ml-2 pt-dot2 pb-dot2" :disabled="deviceInfoJson.co == 0 || deviceInfoJson.op !=0" @click="sendCommand('disconnectWifi')">
                        기기 WiFi 연결끊기
                    </b-button>
                </div>
                <h4 class="border-bottom mt-2 pt-1 pb-1">
                    기본 WiFi 설정
                </h4>
                <b-input-group size="sm" class="mt-1">
                    <b-input-group-text slot="prepend" class="leftCellTitle">
                        <label style="margin-bottom : 0rem" class="fontSizeDot8">WiFi 이름</label>
                    </b-input-group-text>
                    <b-form-input v-touch:swipe.stop v-model="deviceInfoJsonSSID" class="fontSizeDot8"/>
                </b-input-group>    
                <b-input-group size="sm" class="mt-1">
                    <b-input-group-text slot="prepend" class="leftCellTitle">
                        <label style="margin-bottom : 0rem" class="fontSizeDot8">WiFi 비밀번호</label>
                    </b-input-group-text>
                    <b-form-input v-touch:swipe.stop v-model="deviceInfoJsonPassword" class="fontSizeDot8"/>
                </b-input-group>
                <div v-if="isSameMacAddress && isPageDeviceConfigExist">
                    <b-input-group size="sm" class="mt-1" v-if="typeof(pageDevice.config.ss) != 'undefined' && deviceInfoJsonSSID != pageDevice.config.ss">
                        <b-input-group-text slot="prepend" class="leftCellTitle">
                            <label style="margin-bottom : 0rem" class="fontSizeDot8">서버 WiFi 이름</label>
                        </b-input-group-text>
                        <b-form-input v-touch:swipe.stop readonly :value="pageDevice.config.ss" class="fontSizeDot8"/>
                        <b-button variant="primary" class="fontSizeDot8 rounded-right-only" slot="append" @click="applyPageDeviceSSID" v-b-tooltip.hover.top title="서버 WiFi 이름을 기기에 적용">적용</b-button>
                    </b-input-group>    
                    <b-input-group size="sm" class="mt-1" v-if="typeof(pageDevice.config.pw) != 'undefined' && deviceInfoJsonPassword != pageDevice.config.pw">
                        <b-input-group-text slot="prepend" class="leftCellTitle">
                            <label style="margin-bottom : 0rem" class="fontSizeDot8">서버 WiFi 비밀번호</label>
                        </b-input-group-text>
                        <b-form-input v-touch:swipe.stop readonly :value="pageDevice.config.pw" class="fontSizeDot8"/>
                        <b-button variant="primary" class="fontSizeDot8 rounded-right-only" slot="append" @click="applyPageDevicePassword" v-b-tooltip.hover.bottom title="서버 WiFi 비밀번호를 기기에 적용">적용</b-button>
                    </b-input-group>
                </div>
                <div class="mt-1 text-right">
                    <b-button variant="danger" class="fontSizeDot8 pt-dot2 pb-dot2" :disabled="deviceInfoJsonSSID == '' || deviceInfoJsonSSID == deviceInfoJson.ss" @click="sendSetWifi">
                        {{(isSameMacAddress && isPageDeviceConfigExist)? 'WiFi 이름과 비밀번호 모두 적용하기' : 'WiFi 이름과 비밀번호 연결된 기기에 적용하기'}}
                    </b-button>
                </div>
                <h4 class="border-bottom mt-3 pt-1 pb-1">
                    멀티 WiFi 설정
                </h4>
                <div class="mt-1 text-right" v-if="deviceWifiJsonMerged != null">
                    <b-input-group size="sm" class="mt-1" v-for="(item, index) in deviceWifiJsonMerged" :key="index">
                        
                        <b-input-group-text class="p-0 pl-2 pr-2 fontSizeDot8 rounded-left-only border-right-0">
                            <label class="m-0 p-0">SSID</label>
                        </b-input-group-text>
                        <b-form-input v-touch:swipe.stop readonly :value="item.s" class="fontSizeDot8" v-b-tooltip.hover.top title="WiFi 이름"/>

                        <b-input-group-text class="p-0 pl-2 pr-2 fontSizeDot8 rounded-0 border-right-0 border-left-0">
                            <label class="m-0 p-0">비밀번호</label>
                        </b-input-group-text>
                        
                        <b-form-input readonly v-if="typeof(item.p) != 'undefined'" v-touch:swipe.stop :value="item.p" class="fontSizeDot8" v-b-tooltip.hover.top :title="(typeof(item.__p) != 'undefined' && item.p == item.__p)? '연결된 기기와 서버의 WiFi 비밀번호':'연결된 기기의 WiFi 비밀번호'"/>
                        
                        <b-form-input readonly v-else-if="typeof(item.__p) != 'undefined' && (typeof(item.p) == 'undefined' || item.p != item.__p)" v-touch:swipe.stop :value="item.__p" class="fontSizeDot8" v-b-tooltip.hover.top title="서버의 WiFi 비밀번호"/>

                        <b-form-input readonly v-else v-touch:swipe.stop  class="fontSizeDot8" v-b-tooltip.hover.top title="비밀번호 없음"/>

                        <b-input-group-text v-if="typeof(item.__p) == 'undefined' && typeof(item.p) == 'undefined' && typeof(item.__t__) != 'undefined' && typeof(item.__s__) != 'undefined'" slot="append" class="p-0 pl-2 pr-2 fontSizeDot8 rounded-right-only border-left-0 text-blue bg-blue-light leftCellTitleVeryTiny">
                            <label class="m-0 p-0">일치</label>
                        </b-input-group-text>
                        <b-input-group-text v-else-if="typeof(item.__p) == 'undefined' && typeof(item.p) == 'undefined' && typeof(item.__t__) != 'undefined' && typeof(item.__s__) == 'undefined'" slot="append" class="p-0 pl-2 pr-2 fontSizeDot8 rounded-right-only border-left-0 text-blue bg-blue-light leftCellTitleVeryTiny">
                            <label class="m-0 p-0">기기</label>
                        </b-input-group-text>
                        <b-input-group-text v-else-if="typeof(item.__p) == 'undefined' && typeof(item.p) == 'undefined' && typeof(item.__t__) == 'undefined' && typeof(item.__s__) != 'undefined'" slot="append" class="p-0 pl-2 pr-2 fontSizeDot8 rounded-right-only border-left-0 text-blue bg-blue-light leftCellTitleVeryTiny">
                            <label class="m-0 p-0">서버</label>
                        </b-input-group-text>
                        <b-input-group-text v-else-if="typeof(item.__p) != 'undefined' && typeof(item.p) != 'undefined' && item.p == item.__p" slot="append" class="p-0 pl-2 pr-2 fontSizeDot8 rounded-right-only border-left-0 text-blue bg-blue-light leftCellTitleVeryTiny">
                            <label class="m-0 p-0">일치</label>
                        </b-input-group-text>
                        <b-input-group-text v-else-if="typeof(item.__p) != 'undefined' && typeof(item.p) != 'undefined' && item.p != item.__p" slot="append" class="p-0 pl-2 pr-2 fontSizeDot8 rounded-right-only border-left-0 text-blue bg-blue-light leftCellTitleVeryTiny">
                            <label class="m-0 p-0">다름</label>
                        </b-input-group-text>
                        <b-input-group-text v-else-if="typeof(item.__p) == 'undefined'" slot="append" class="p-0 pl-2 pr-2 fontSizeDot8 rounded-right-only border-left-0 text-blue bg-blue-light leftCellTitleVeryTiny">
                            <label class="m-0 p-0">기기</label>
                        </b-input-group-text>
                        <b-input-group-text v-else-if="typeof(item.p) == 'undefined'" slot="append" class="p-0 pl-2 pr-2 fontSizeDot8 rounded-right-only border-left-0 text-blue bg-blue-light leftCellTitleVeryTiny">
                            <label class="m-0 p-0">서버</label>
                        </b-input-group-text>
                    </b-input-group>    
                </div>    

                <div>
                    <b-input-group size="sm" class="mt-2">
                        <b-input-group-text slot="prepend" class="leftCellTitle">
                            <label style="margin-bottom : 0rem" class="fontSizeDot8">새 WiFi 이름</label>
                        </b-input-group-text>
                        <b-form-input v-touch:swipe.stop v-model="deviceWifiJsonNewSSID" trim class="fontSizeDot8" maxlength="32" minlength="1" size="sm" pattern='^[^!#;+\]\/"\t][^+\]\/"\t]{0,30}[^ !#;+\]\/"\t]$|^[^ !#;+\]\/"\t]$' v-b-tooltip.focus title='연결할 Wifi의 이름(SSID). 32글자까지 가능. 영문 대소문자, 숫자, _, - 등 일부 기호만 사용 가능하며, 한글, 공백문자, ?, ", $, [, \, ], +는 사용할 수 없습니다.'/>
                    </b-input-group>    
                    <b-input-group size="sm" class="mt-1">
                        <b-input-group-text slot="prepend" class="leftCellTitle">
                            <label style="margin-bottom : 0rem" class="fontSizeDot8">새 WiFi 비밀번호</label>
                        </b-input-group-text>
                        <b-form-input v-touch:swipe.stop v-model="deviceWifiJsonNewPassword" trim class="fontSizeDot8" maxlength="32" minlength="1" v-b-tooltip.focus title="연결할 Wifi의 패스워드. 32글자까지 가능."/>
                    </b-input-group>
                </div>

                <div class="mt-1 text-right" v-if="deviceWifiJsonPooled">
                    <b-button variant="danger" class="fontSizeDot8 pt-dot2 pb-dot2" @click="sendAddWifi" :disabled="deviceWifiJsonNewSSID == '' || deviceWifiJsonMerged == null || Object.keys(deviceWifiJsonMerged).includes(deviceWifiJsonNewSSID)">
                        {{isSameMacAddress? '새 WiFi 이름과 비밀번호 모두 추가하기' : '새 WiFi 이름과 비밀번호 연결된 기기에 적용하기'}}
                    </b-button>
                </div>
                <div class="mt-3" v-if="deviceWifiJsonPooled">

                    <b-button variant="primary" class="w-100 fontSizeDot8 pt-dot2 pb-dot2" @click="sendUpWifi" :disabled="deviceInfoJson.co == 0 || deviceInfoJson.op == 1 || !isSameMacAddress || deviceWifiJson == null || deviceWifiJson.length == 0">
                        연결된 기기의 멀티 WiFi 설정을 서버로 업로드 하기
                    </b-button>

                    <b-button variant="primary" class="w-100 fontSizeDot8 pt-dot2 pb-dot2 mt-1" @click="sendDownWifi" :disabled="deviceInfoJson.co == 0 || deviceInfoJson.op == 1 || !isSameMacAddress || typeof(pageDevice.wifi) == 'undefined' || pageDevice.wifi.length == 0">
                        서버의 멀티 WiFi 설정을 연결된 기기로 다운로드 하기
                    </b-button>

                    <div class="mt-1" v-if="deviceWifiJsonPooled">
                        <b-button variant="secondary" class="w-100 fontSizeDot8 pt-dot2 pb-dot2" @click="removeWifi" :disabled="deviceInfoJson.co == 0 || deviceInfoJson.op == 1 || deviceWifiJson == null || !isSameMacAddress">
                            멀티 WiFi 설정 모두 지우기
                        </b-button>
                    </div>

                    
            </div>
            </div>
            <template slot="modal-footer">
                <b-button variant="secondary" size="sm" id="hideConfigDeviceWifiFloat" @click="hideModal('configDeviceWifiFloat')">
                    닫기
                </b-button>
            </template>
        </b-modal>

        <b-modal v-touch:swipe.stop size="lg" id="configDeviceConfigFloat"
        tabindex="-1" title="기기 설정하기" static @show="modalShowFocus" data-nextfocus="hideConfigDeviceConfigFloat" header-bg-variant="primary" header-text-variant="light" footer-bg-variant="light" footer-text-variant="primary" header-class="pt-2 pb-2 pr-3 pl-3" footer-class="pt-1 pb-1 pr-3 pl-3" content-class="border-0" button-size="sm">
            <div v-if="serialPort != null && deviceInfoJson != null">

                <b-alert class="m-0 mb-2 p-1 pl-2 fontSizeDot8" show variant="danger" v-if="deviceInfoJson != null && !isSameMacAddress && !isSameAcode">
                    <div>
                        <b>주의! 연결된 기기가 현 페이지 기기가 아닙니다</b>(연결된 기기 MAC주소: {{deviceInfoJson.ma}}, 현 페이지 기기 MAC주소: {{pageDevice.macAddress}})
                    </div>
                    <div class="mt-1" v-if="deviceDid != ''">
                        <router-link :to="{ name: 'tinkDevice', params: { did: deviceDid }, query: { mode: 'serial'}}" custom v-slot="{ navigate }">
                            <b-button @click="navigate" @keypress.enter="navigate" size="sm" variant="danger" class="fontSizeDot8 p-dot1 pl-1 pr-1" role="link">
                                연결된 기기의 페이지로 이동하기
                            </b-button>
                        </router-link>
                    </div>                
                </b-alert>

                <b-alert class="m-0 mt-2 mb-0 p-1 pl-2 fontSizeDot8" show variant="danger" v-if="deviceInfoJson != null && isSameMacAddress && deviceInfoJson.ac != '' && deviceInfoJson.ac != '' &&deviceInfoJson.ac != pageDevice.acode">
                    <div>
                        <b>주의! 연결된 기기의 접속코드가 서버의 접속코드와 다릅니다</b>. 서버에서 기기를 삭제하고 다시 등록한 다음에는 기기 초기화가 필요합니다.
                    </div>
                    <div class="mt-1" v-if="serial != ''">
                        <b-button @click="sendCommand('resetSystem')" size="sm" variant="danger" class="fontSizeDot8 p-dot1 pl-1 pr-1">
                                연결된 기기 초기화하기
                        </b-button>
                    </div>                
                </b-alert>

                <b-form v-if="deviceConfigJson != null" @submit.stop.prevent class="was-validated">
                    <b-input-group size="sm" class="mt-1">
                        <b-input-group-text class="p-0 pl-2 pr-2 fontSizeDot8 rounded-left-only border-right-0 leftCellTitleVeryTiny">
                            <label class="m-0 p-0">버전</label>
                        </b-input-group-text>
                        <b-form-input v-touch:swipe.stop trim type="number" min="1" max="2000000000" v-model="deviceConfigJson.ve" :class="`fontSizeDot8 ${configClass(deviceConfigJson.ve, deviceConfigJsonOriginal.ve, pageDevice.config.ve)}`" v-b-tooltip.hover.top :title="configTitle(deviceConfigJson.ve, deviceConfigJsonOriginal.ve, pageDevice.config.ve)"/>
                    </b-input-group>

                    <b-input-group size="sm" class="mt-1">
                        <b-input-group-text class="p-0 pl-2 pr-2 fontSizeDot8 rounded-left-only border-right-0 leftCellTitleVeryTiny">
                            <label class="m-0 p-0">접속코드</label>
                        </b-input-group-text>
                        <b-form-input v-touch:swipe.stop trim minlength="20" maxlength="20" v-model="deviceConfigJson.ac" :class="`fontSizeDot8 ${configClass(deviceConfigJson.ac, deviceConfigJsonOriginal.ac, pageDevice.config.ac)}`" v-b-tooltip.hover.top :title="configTitle(deviceConfigJson.ac, deviceConfigJsonOriginal.ac, pageDevice.config.ac)"/>
                    </b-input-group>    

                    <b-input-group size="sm" class="mt-1">
                        <b-input-group-text class="p-0 pl-2 pr-2 fontSizeDot8 rounded-left-only border-right-0 leftCellTitleVeryTiny">
                            <label class="m-0 p-0">업데이트 간격</label>
                        </b-input-group-text>
                        <b-form-input v-touch:swipe.stop trim type="number" min="60000" max="86400000" v-model="deviceConfigJson.ui" :class="`fontSizeDot8 ${configClass(deviceConfigJson.ui, deviceConfigJsonOriginal.ui, pageDevice.config.ui)}`" v-b-tooltip.hover.top :title="configTitle(deviceConfigJson.ui, deviceConfigJsonOriginal.ui, pageDevice.config.ui)"/>
                    </b-input-group>    

                    <b-input-group size="sm" class="mt-3">
                        <b-input-group-text class="p-0 pl-2 pr-2 fontSizeDot8 rounded-left-only border-right-0 leftCellTitleVeryTiny">
                            <label class="m-0 p-0">WiFi 이름</label>
                        </b-input-group-text>
                        <b-form-input v-touch:swipe.stop trim minlength="1" maxlength="32" pattern='^[^!#;+\]\/"\t][^+\]\/"\t ]{0,30}[^ !#;+\]\/"\t]$|^[^ !#;+\]\/"\t]$' v-model="deviceConfigJson.ss" :class="`fontSizeDot8 ${configClass(deviceConfigJson.ss, deviceConfigJsonOriginal.ss, pageDevice.config.ss)}`" v-b-tooltip.hover.top :title="configTitle(deviceConfigJson.ss, deviceConfigJsonOriginal.ss, pageDevice.config.ss)"/>
                    </b-input-group>    

                    <b-input-group size="sm" class="mt-1">
                        <b-input-group-text class="p-0 pl-2 pr-2 fontSizeDot8 rounded-left-only border-right-0 leftCellTitleVeryTiny">
                            <label class="m-0 p-0">WiFi 비밀번호</label>
                        </b-input-group-text>
                        <b-form-input v-touch:swipe.stop trim maxlength="32" minlength="2" v-model="deviceConfigJson.pw" :class="`fontSizeDot8 ${configClass(deviceConfigJson.pw, deviceConfigJsonOriginal.pw, pageDevice.config.pw)}`" v-b-tooltip.hover.top :title="configTitle(deviceConfigJson.pw, deviceConfigJsonOriginal.pw, pageDevice.config.pw)"/>
                    </b-input-group>    

                    <b-input-group size="sm" class="mt-1">
                        <b-input-group-text class="p-0 pl-2 pr-2 fontSizeDot8 rounded-left-only border-right-0 leftCellTitleVeryTiny">
                            <label class="m-0 p-0">WiFi 확인간격</label>
                        </b-input-group-text>
                        <b-form-input v-touch:swipe.stop trim type="number" max="86400000" min="180000" v-model="deviceConfigJson.wi" :class="`fontSizeDot8 ${configClass(deviceConfigJson.wi, deviceConfigJsonOriginal.wi, pageDevice.config.wi)}`" v-b-tooltip.hover.top :title="configTitle(deviceConfigJson.wi, deviceConfigJsonOriginal.wi, pageDevice.config.wi)"/>
                    </b-input-group>    

                    <b-input-group size="sm" class="mt-3">
                        <b-input-group-text class="p-0 pl-2 pr-2 fontSizeDot8 rounded-left-only border-right-0 leftCellTitleVeryTiny">
                            <label class="m-0 p-0">SLEEP 간격</label>
                        </b-input-group-text>
                        <b-form-input v-touch:swipe.stop trim type="number" max="10800000" min="300000" v-model="deviceConfigJson.si" :class="`fontSizeDot8 ${configClass(deviceConfigJson.si, deviceConfigJsonOriginal.si, pageDevice.config.si)}`" v-b-tooltip.hover.top :title="configTitle(deviceConfigJson.si, deviceConfigJsonOriginal.si, pageDevice.config.si)"/>
                    </b-input-group>    

                    <b-input-group size="sm" class="mt-1">
                        <b-input-group-text class="p-0 pl-2 pr-2 fontSizeDot8 rounded-left-only border-right-0 leftCellTitleVeryTiny">
                            <label class="m-0 p-0">읽기 지연 시간</label>
                        </b-input-group-text>
                        <b-form-input v-touch:swipe.stop trim type="number" max="300000" min="5000" v-model="deviceConfigJson.sr" :class="`fontSizeDot8 ${configClass(deviceConfigJson.sr, deviceConfigJsonOriginal.sr, pageDevice.config.sr)}`" v-b-tooltip.hover.top :title="configTitle(deviceConfigJson.sr, deviceConfigJsonOriginal.sr, pageDevice.config.sr)"/>
                    </b-input-group>    

                    <b-input-group size="sm" class="mt-1">
                        <b-input-group-text class="p-0 pl-2 pr-2 fontSizeDot8 rounded-left-only border-right-0 leftCellTitleTiny">
                            <label class="m-0 p-0">SLEEP 읽기 시간</label>
                        </b-input-group-text>
                        <b-form-input v-touch:swipe.stop trim readonly type="number" max="300000" min="5000" :value="configSleepSaveBinary" :class="`fontSizeDot8 ${configClass(configSleepSaveBinary, deviceConfigJsonOriginal.sl, pageDevice.config.sl)}`" v-b-tooltip.hover.top :title="configTitle(configSleepSaveBinary, deviceConfigJsonOriginal.sl, pageDevice.config.sl)"/>
                        <b-button variant="primary" class="fontSizeDot8 rounded-0" slot="append" v-b-modal.configSleepSaveFloat>수정</b-button>
                    </b-input-group>

                    <b-input-group size="sm" class="mt-1">
                        <b-input-group-text class="p-0 pl-2 pr-2 fontSizeDot8 rounded-left-only border-right-0 leftCellTitleTiny">
                            <label class="m-0 p-0">SLEEP 업데이트 시간</label>
                        </b-input-group-text>
                        <b-form-input v-touch:swipe.stop trim readonly type="number" max="300000" min="5000" :value="configSleepUpdateBinary" :class="`fontSizeDot8 ${configClass(configSleepUpdateBinary, deviceConfigJsonOriginal.su, pageDevice.config.su)}`" v-b-tooltip.hover.top :title="configTitle(configSleepUpdateBinary, deviceConfigJsonOriginal.su, pageDevice.config.su)"/>
                        <b-button variant="primary" class="fontSizeDot8 rounded-0" slot="append" v-b-modal.configSleepUpdateFloat>수정</b-button>
                    </b-input-group>

                    <b-input-group size="sm" class="mt-3">
                        <b-input-group-text class="p-0 pl-2 pr-2 fontSizeDot8 rounded-left-only border-right-0 leftCellTitleTiny">
                            <label class="m-0 p-0">재부팅 시간</label>
                        </b-input-group-text>
                        <b-form-input v-touch:swipe.stop trim readonly type="number" max="300000" min="5000" :value="configRebootBinary" :class="`fontSizeDot8 ${configClass(configRebootBinary, deviceConfigJsonOriginal.rb, pageDevice.config.rb)}`" v-b-tooltip.hover.top :title="configTitle(configRebootBinary, deviceConfigJsonOriginal.rb, pageDevice.config.rb)"/>
                        <b-button variant="primary" class="fontSizeDot8 rounded-0" slot="append" v-b-modal.configRebootFloat>수정</b-button>
                    </b-input-group>

                    <b-input-group size="sm" class="mt-1 mb-3">
                        <b-input-group-text class="p-0 pl-2 pr-2 fontSizeDot8 rounded-left-only border-right-0 leftCellTitleTiny">
                            <label class="m-0 p-0">이진 설정 값</label>
                        </b-input-group-text>
                        <b-form-input v-touch:swipe.stop trim readonly type="number" max="300000" min="5000" :value="configStatusBinary" :class="`fontSizeDot8 ${configClass(configStatusBinary, deviceConfigJsonOriginal.st, pageDevice.config.st)}`" v-b-tooltip.hover.top :title="configTitle(configStatusBinary, deviceConfigJsonOriginal.st, pageDevice.config.st)"/>
                        <b-button :variant="showconfigStatusInputList? 'primary':'danger'" class="fontSizeDot8 rounded-0" slot="append" @click="showconfigStatusInputList = !showconfigStatusInputList" v-b-tooltip.hover title="아래 상세 설정을 수정하면 이진 설정 값에 반영됩니다.">{{ showconfigStatusInputList? '닫기':'수정'}}</b-button>
                    </b-input-group>

                    <div v-if="deviceConfigJson != null" class="mt-1" :style="showconfigStatusInputList? 'display: block':'display: none;'">
                        <b-input-group size="sm" class="mt-1" v-for="(item, index) in configStatusInputList" :key="index">
                            <b-input-group-text slot="prepend" class="p-0 pl-2 pr-2 fontSizeDot8 rounded-left-only border-right-0 leftCellTitle">
                                <label :for="item.id" class="m-0 p-0">{{item.title}} [{{item.pos+1}}]</label>
                            </b-input-group-text>
                            <b-form-select v-model="item.value" :id="item.id" :disabled="!isLoginUserPageUser || item.disabled === true" required v-b-tooltip.focus :title="(isSameMacAddress && typeof(pageDevice.config) != 'undefined' && item.value == item.__value)? '서버와 일치. ' + item.details: '서버와 다름. ' + item.details" size="sm" :class="(isSameMacAddress && typeof(pageDevice.config) != 'undefined' && item.value == item.__value)? 'fontSizeDot8': 'fontSizeDot8 text-danger bg-danger-light'">
                                <option :value="0">사용안함(0)</option>
                                <option :value="1">사용(1)</option>
                            </b-form-select>
                        </b-input-group>
                    </div>    


                    <div class="mt-3">
                        <b-button variant="danger" class="w-100 fontSizeDot8 pt-dot2 pb-dot2" @click="saveConfig" :disabled="deviceInfoJson.co == 0 || deviceInfoJson.op == 1">
                            {{isSameMacAddress? '수정된 설정을 연결된 기기와 서버에 모두 반영하기' : '수정된 설정을 연결된 기기에 반영하기'}}
                        </b-button>

                        <b-button variant="secondary" class="w-100 fontSizeDot8 pt-dot2 pb-dot2 mt-2" @click="sendUpConfig" :disabled="deviceInfoJson.co == 0 || deviceInfoJson.op == 1">
                            연결된 기기의 설정을 서버로 업로드 하기
                        </b-button>

                        <b-button variant="secondary" class="w-100 fontSizeDot8 pt-dot2 pb-dot2 mt-1" @click="sendDownConfig" :disabled="deviceInfoJson.co == 0 || deviceInfoJson.op == 1 || !isSameMacAddress">
                            서버의 설정을 연결된 기기로 다운로드 하기
                        </b-button>
                    </div>    

                </b-form>

                <div v-else class="mt-3 mb-3 pt-2 pb-2 border-top border-bottom gothic text-center fontSizeDot9">
                    <div v-if="contentWritten == 'print /config.json'">
                        <b-spinner type="grow" small variant="primary"></b-spinner>
                            기기 설정 가져오는 중
                        <b-spinner type="grow" small variant="primary"></b-spinner>
                    </div>
                    <div class="mt-2">
                        <b-button size="sm" variant="primary" class="fontSizeDot8 p-dot1 pl-1 pr-1" @click="sendCommand('print /config.json');">
                            기기 설정 다시 가져오기
                        </b-button>
                    </div>    
                </div>    


            </div>    
            <template slot="modal-footer">
                <b-button variant="secondary" size="sm" id="hideConfigDeviceConfigFloat" @click="hideModal('configDeviceConfigFloat')">
                    닫기
                </b-button>
            </template>
        </b-modal>

        <b-modal v-touch:swipe.stop size="lg" id="configDeviceSensorsFloat"
        tabindex="-1" title="기기 센서 설정하기" static @show="modalShowFocus" data-nextfocus="hideConfigDeviceSensorsFloat" header-bg-variant="primary" header-text-variant="light" footer-bg-variant="light" footer-text-variant="primary" header-class="pt-2 pb-2 pr-3 pl-3" footer-class="pt-1 pb-1 pr-3 pl-3" content-class="border-0" button-size="sm">

            <div v-if="serialPort != null && deviceInfoJson != null && deviceSensorsJson != null">

                <b-alert class="m-0 mb-2 p-1 pl-2 fontSizeDot8" show variant="danger" v-if="deviceInfoJson != null && !isSameMacAddress && !isSameAcode">
                    <div>
                        <b>주의! 연결된 기기가 현 페이지 기기가 아닙니다</b>(연결된 기기 MAC주소: {{deviceInfoJson.ma}}, 현 페이지 기기 MAC주소: {{pageDevice.macAddress}})
                    </div>
                    <div class="mt-1" v-if="deviceDid != ''">
                        <router-link :to="{ name: 'tinkDevice', params: { did: deviceDid }, query: { mode: 'serial'}}" custom v-slot="{ navigate }">
                            <b-button @click="navigate" @keypress.enter="navigate" size="sm" variant="danger" class="fontSizeDot8 p-dot1 pl-1 pr-1" role="link">
                                연결된 기기의 페이지로 이동하기
                            </b-button>
                        </router-link>
                    </div>                
                </b-alert>

                <b-alert class="m-0 mt-2 mb-0 p-1 pl-2 fontSizeDot8" show variant="danger" v-if="deviceInfoJson != null && isSameMacAddress && deviceInfoJson.ac != '' && deviceInfoJson.ac != '' &&deviceInfoJson.ac != pageDevice.acode">
                    <div>
                        <b>주의! 연결된 기기의 접속코드가 서버의 접속코드와 다릅니다</b>. 서버에서 기기를 삭제하고 다시 등록한 다음에는 기기 초기화가 필요합니다.
                    </div>
                    <div class="mt-1" v-if="serial != ''">
                        <b-button @click="sendCommand('resetSystem')" size="sm" variant="danger" class="fontSizeDot8 p-dot1 pl-1 pr-1">
                                연결된 기기 초기화하기
                        </b-button>
                    </div>                
                </b-alert>

                <div class="gothic fontSizeDot8 bg-secondary-light p-2 mt-0 mb-2">
                    여기서는 서버의 센서 설정을 연결된 기기로 다운로드 하거나 연결된 기기에 새로 추가된 센서의 설정을 서버로 업로드할 수 있습니다. 자세한 센서 설정은 
                    <router-link :to="{ name: 'tinkDevice', params: { did: pageDevice.id }, query: { mode: 'sensors'} }" custom v-slot="{ navigate }">
                        <a @click="navigate" @keypress.enter="navigate" class="cursor-pointer text-blue font-weight-bold" role="link">
                        센서설정 탭
                        </a>  
                    </router-link>에서 센서를 수정한 다음에 기기를 껐다켜면 됩니다.
                </div>

                <div v-for="(sensor, name) in deviceSensorsJsonMerged" :key="name" class="mt-2">    

                    <b-input-group size="sm">
                        <b-input-group-text class="p-0 pl-2 pr-2 fontSizeDot8 rounded-0 border-right-0 leftCellTitle font-weight-bold">
                            <label class="m-0 p-0 text-primary">{{name}} 센서</label>
                        </b-input-group-text>
                        <b-form-input v-touch:swipe.stop :value="(typeof(sensor.ty) != 'undefined')? '연결된 기기' : '연결된 기기 <없음>'" trim disabled readonly :class="(typeof(sensor.ty) != 'undefined')? 'fontSizeDot8 rounded-0 text-center' : 'fontSizeDot8 rounded-0 text-center text-danger bg-danger-light'"/>


                        <b-form-input v-touch:swipe.stop :value="(typeof(sensor.__ty) != 'undefined')?'서버':'서버 <없음>'" trim disabled readonly :class="(typeof(sensor.__ty) != 'undefined')?'fontSizeDot8 rounded-0 text-center':'fontSizeDot8 rounded-0 text-center text-danger bg-danger-light'" v-if="isSameMacAddress"/>
                    </b-input-group>

                    <b-input-group size="sm" v-if="typeof(sensor.ty) != 'undefined' || typeof(sensor.__ty) != !'undefined'">
                        <b-input-group-text class="p-0 pl-2 pr-2 fontSizeDot8 rounded-0 border-right-0 border-top-0 leftCellTitle">
                            <label class="m-0 p-0">타입</label>
                        </b-input-group-text>
                        <b-form-input v-touch:swipe.stop :value="(typeof(sensor.ty) != 'undefined')? sensorTypeByIndex[sensor.ty]: '없음'" trim disabled readonly :class="`fontSizeDot8 rounded-0 border-top-0 text-right ${(((typeof(sensor.ty) == 'undefined') || (typeof(sensor.__ty) == 'undefined') || (sensor.ty != sensor.__ty))&&isSameMacAddress)? 'bg-danger-light text-danger':'bg-white'}`"/>
                        <b-form-input v-if="isSameMacAddress" v-touch:swipe.stop :value="(typeof(sensor.__ty) != 'undefined')? sensorTypeByIndex[sensor.__ty]: '없음'" trim disabled readonly :class="`fontSizeDot8 rounded-0 border-top-0 text-right ${((typeof(sensor.ty) == 'undefined') || (typeof(sensor.__ty) == 'undefined') || (sensor.ty != sensor.__ty))? 'bg-danger-light text-danger':'bg-white'}`"/>
                    </b-input-group>

                    <div v-for="item, index in sensorCompareList" :key="index">
                        <b-input-group size="sm" v-if="!(typeof(sensor[item.name]) == 'undefined' && typeof(sensor['__' + item.name]) == 'undefined')">
                            <b-input-group-text class="p-0 pl-2 pr-2 fontSizeDot8 rounded-0 border-right-0 border-top-0 leftCellTitle">
                                <label class="m-0 p-0">{{item.title}}</label>
                            </b-input-group-text>
                            <b-form-input v-touch:swipe.stop :value="(typeof(sensor[item.name]) != 'undefined')? sensor[item.name]: '없음'" trim disabled readonly :class="`fontSizeDot8 rounded-0 border-top-0 text-right ${(((typeof(sensor[item.name]) == 'undefined') || (typeof(sensor['__' + item.name]) == 'undefined') || (sensor[item.name] != sensor['__' + item.name]))&&isSameMacAddress)? 'bg-danger-light text-danger':'bg-white'}`"/>

                            <b-form-input v-if="isSameMacAddress" v-touch:swipe.stop :value="(typeof(sensor['__'+item.name]) != 'undefined')? sensor['__'+item.name]: '없음'" trim disabled readonly :class="`fontSizeDot8 rounded-0 border-top-0 text-right ${((typeof(sensor[item.name]) == 'undefined') || (typeof(sensor['__'+item.name]) == 'undefined') || (sensor[item.name] != sensor['__'+item.name]))? 'bg-danger-light text-danger':'bg-white'}`"/>
                        </b-input-group>
                    </div>


                    <div v-if="typeof(sensor.va) != 'undefined' && typeof(sensor.__va) != 'undefined'">
                        <div v-for="value, valueIndex in sensor.va" :key="valueIndex">
                            <div v-for="item, index in sensorCompareValueList" :key="'value' + index">
                                <b-input-group size="sm" v-if="!(typeof(value[item.name]) == 'undefined' && typeof(sensor.__va[valueIndex][item.name]) == 'undefined')">
                                    <b-input-group-text class="p-0 pl-2 pr-2 fontSizeDot8 rounded-0 border-right-0 border-top-0 leftCellTitle">
                                        <label class="m-0 p-0">[{{valueIndex}}] {{value.na}} {{item.title}}</label>
                                    </b-input-group-text>

                                    <b-form-input v-touch:swipe.stop :value="(typeof(value[item.name]) != 'undefined')? value[item.name]: '없음'" trim disabled readonly :class="`fontSizeDot8 rounded-0 border-top-0 text-right ${(((typeof(value[item.name]) == 'undefined') || valueIndex >= sensor.__va.length || (typeof(sensor.__va[valueIndex][item.name]) == 'undefined') || (value[item.name] != sensor.__va[valueIndex][item.name]))&&isSameMacAddress)? 'bg-danger-light text-danger':'bg-white'}`"/>

                                    <b-form-input v-if="isSameMacAddress" v-touch:swipe.stop :value="(typeof(sensor.__va[valueIndex][item.name]) != 'undefined')? sensor.__va[valueIndex][item.name]: '없음'" trim disabled readonly :class="`fontSizeDot8 rounded-0 border-top-0 text-right ${((typeof(value[item.name]) == 'undefined') || valueIndex >= sensor.__va.length || (typeof(sensor.__va[valueIndex][item.name]) == 'undefined') || (value[item.name] != sensor.__va[valueIndex][item.name]))? 'bg-danger-light text-danger':'bg-white'}`"/>
                                </b-input-group>
                            </div>
                        </div>

                        <div v-for="value, valueIndex in sensor.__va" :key="'__'+valueIndex">
                            <div v-if="valueIndex >= sensor.va.length">
                                <div v-for="item, index in sensorCompareValueList" :key="'__value' + index">
                                    <b-input-group size="sm" v-if="typeof(sensor.__va[valueIndex][item.name]) != 'undefined'">
                                        <b-input-group-text class="p-0 pl-2 pr-2 fontSizeDot8 rounded-0 border-right-0 border-top-0 leftCellTitle">
                                            <label class="m-0 p-0">[{{valueIndex}}] {{value.na}} {{item.title}}</label>
                                        </b-input-group-text>

                                        <b-form-input v-touch:swipe.stop value="없음" trim disabled readonly :class="`fontSizeDot8 rounded-0 border-top-0 text-right ${isSameMacAddress? 'bg-danger-light text-danger':'bg-white'}`"/>

                                        <b-form-input v-if="isSameMacAddress" v-touch:swipe.stop :value="sensor.__va[valueIndex][item.name]" trim disabled readonly class="fontSizeDot8 rounded-0 border-top-0 text-right bg-danger-light text-danger"/>
                                        
                                    </b-input-group>
                                </div>    
                            </div>    
                        </div>    
                    </div>


                    <div v-else-if="typeof(sensor.va) != 'undefined' && typeof(sensor.__va) == 'undefined'">
                        <div v-for="value, valueIndex in sensor.va" :key="valueIndex">
                            <div v-for="item, index in sensorCompareValueList" :key="'value' + index">
                                <b-input-group size="sm" v-if="typeof(value[item.name]) != 'undefined'">
                                    <b-input-group-text class="p-0 pl-2 pr-2 fontSizeDot8 rounded-0 border-right-0 border-top-0 leftCellTitle">
                                        <label class="m-0 p-0">[{{valueIndex}}] {{value.na}} {{item.title}}</label>
                                    </b-input-group-text>

                                    <b-form-input v-touch:swipe.stop :value="value[item.name]" trim disabled readonly :class="`fontSizeDot8 rounded-0 border-top-0 text-right  ${isSameMacAddress? 'bg-danger-light text-danger':'bg-white'}`"/>

                                    <b-form-input v-if="isSameMacAddress" v-touch:swipe.stop value="없음" trim disabled readonly class="fontSizeDot8 rounded-0 border-top-0 text-right bg-danger-light text-danger"/>
                                </b-input-group>
                            </div>
                        </div>
                    </div>

                    <div v-if="typeof(sensor.va) == 'undefined' && typeof(sensor.__va) != 'undefined'">
                        <div v-for="value, valueIndex in sensor.__va" :key="'__'+valueIndex">
                            <div v-for="item, index in sensorCompareValueList" :key="'__value' + index">
                                <b-input-group size="sm" v-if="typeof(sensor.__va[valueIndex][item.name]) != 'undefined'">
                                    <b-input-group-text class="p-0 pl-2 pr-2 fontSizeDot8 rounded-0 border-right-0 border-top-0 leftCellTitle">
                                        <label class="m-0 p-0">[{{valueIndex}}] {{value.na}} {{item.title}}</label>
                                    </b-input-group-text>

                                    <b-form-input v-touch:swipe.stop value="없음" trim disabled readonly :class="`fontSizeDot8 rounded-0 border-top-0 text-right bg-danger-light  ${isSameMacAddress? 'bg-danger-light text-danger':'bg-white'}`"/>

                                    <b-form-input v-if="isSameMacAddress" v-touch:swipe.stop :value="sensor.__va[valueIndex][item.name]" trim disabled readonly class="fontSizeDot8 rounded-0 border-top-0 text-right bg-danger-light text-danger"/>
                                    
                                </b-input-group>
                            </div>    
                        </div>    
                    </div>
                </div>    


                <div class="mt-3 mb-2">
                    <b-button variant="danger" class="w-100 fontSizeDot8 pt-dot2 pb-dot2 mt-1" @click="sendUpSensors" :disabled="deviceInfoJson.co == 0 || deviceInfoJson.op == 1" v-if="deviceNewSensors.length != 0 && isSameMacAddress">
                        연결된 기기에 새로 추가된 {{deviceNewSensors.join(", ")}} 센서 설정을 서버로 업로드하기
                    </b-button>

                    <b-button variant="danger" class="w-100 fontSizeDot8 pt-dot2 pb-dot2 mt-1" @click="sendDownSensors" :disabled="deviceInfoJson.co == 0 || deviceInfoJson.op == 1">
                        서버의 센서 설정을 연결된 기기로 다운로드 하기
                    </b-button>
                </div>    


            </div>

            <div v-else class="mt-3 mb-3 pt-2 pb-2 border-top border-bottom gothic text-center fontSizeDot9">
                <div v-if="contentWritten == 'print /sensors.json'">
                    <b-spinner type="grow" small variant="primary"></b-spinner>
                        센서 설정 가져오는 중
                    <b-spinner type="grow" small variant="primary"></b-spinner>
                </div>
                <div class="mt-2">
                    <b-button size="sm" variant="primary" class="fontSizeDot8 p-dot1 pl-1 pr-1" @click="sendCommand('print /sensors.json');">
                        센서 설정 다시 가져오기
                    </b-button>
                </div>    
            </div>    


            <template slot="modal-footer">
                <b-button variant="secondary" size="sm" id="hideConfigDeviceSensorsFloat" @click="hideModal('configDeviceSensorsFloat')">
                    닫기
                </b-button>
            </template>

        </b-modal>

        <b-modal v-touch:swipe.stop v-if="!pageDevice.disabled" size="lg" id="configRebootFloat"
        tabindex="-1" title="자동 리부팅(Config Reboot) 설정" static
        @show="modalShowFocus" data-nextfocus="configRebootUse" header-bg-variant="primary" header-text-variant="light" footer-bg-variant="light" footer-text-variant="primary" header-class="pt-2 pb-2 pr-3 pl-3" footer-class="pt-1 pb-1 pr-3 pl-3" content-class="border-0" button-size="sm">

        <p class="mb-1 fontSizeDot9 gothic">
            특정 요일, 시간에 기기를 자동으로 껐다 켤 수 있습니다. 일주일에 한번 정도 기기를 리부팅하면 시스템을 건강한 상태로 유지할 수 있습니다.
        </p>

        <b-form @submit.stop.prevent class="m-3">

            <b-form-group class="mb-3">
            <b-form-checkbox v-model="configRebootUse" id="configRebootUse" switch size="sm" class="fontSizeDot9">사용</b-form-checkbox>
            </b-form-group>

            <b-form-group v-slot="{ ariaDescribedby }" class="mb-4">
            <b-form-checkbox-group v-model="configRebootWeekSelected" :options="configRebootWeekOptions"
                :aria-describedby="ariaDescribedby" plain :disabled="configRebootUse != '1'" class="fontSizeDot9"></b-form-checkbox-group>
            <div class="text-right">
                <b-button size="sm" :disabled="configRebootUse != '1'" class="pl-2 pr-2 pt-dot1 pb-dot1 mr-2 fontSizeDot8" @click="checkAll(configRebootWeekOptions, 'configRebootWeekSelected')">모두 선택</b-button>
                <b-button size="sm" :disabled="configRebootUse != '1'" class="pl-2 pr-2 pt-dot1 pb-dot1 mr-2 fontSizeDot8" @click="uncheckAll('configRebootWeekSelected')">선택 취소</b-button>
            </div>
            </b-form-group>

            <b-form-group v-slot="{ ariaDescribedby }">
            <b-form-checkbox-group v-model="configRebootHoursSelected" :options="configRebootHoursOptions"
                :aria-describedby="ariaDescribedby" plain :disabled="configRebootUse != '1'" class="fontSizeDot9"></b-form-checkbox-group>
            <div class="text-right">
                <b-button size="sm" :disabled="configRebootUse != '1'" class="pl-2 pr-2 pt-dot1 pb-dot1 mr-2 fontSizeDot8"  @click="checkAll(configRebootHoursOptions, 'configRebootHoursSelected')">모두 선택</b-button>
                <b-button size="sm" :disabled="configRebootUse != '1'" class="pl-2 pr-2 pt-dot1 pb-dot1 mr-2 fontSizeDot8" @click="uncheckAll('configRebootHoursSelected')">선택 취소</b-button>
            </div>
            </b-form-group>
        </b-form>

        <template slot="modal-footer">
            <b-button variant="primary" size="sm" @click="hideModal('configRebootFloat')">
            닫기
            </b-button>
        </template>

        </b-modal>

        <b-modal v-touch:swipe.stop v-if="!pageDevice.disabled" size="lg" id="configSleepSaveFloat"
        tabindex="-1" title="SLEEP 읽기 요일과 시간 설정 (Config Sleep Save)" static
        @show="modalShowFocus" data-nextfocus="configSleepSaveUse" header-bg-variant="primary" header-text-variant="light" footer-bg-variant="light" footer-text-variant="primary" header-class="pt-2 pb-2 pr-3 pl-3" footer-class="pt-1 pb-1 pr-3 pl-3" content-class="border-0" button-size="sm">

        <p class="mb-1 fontSizeDot9 gothic">
            Sleep 모드에서 특정 요일, 시간에 센서를 측정해서 저장할 수 있습니다. 시간이 선택된 경우, Sleep Interval 속성이 600000(10분)이면 0분, 10분, 20분, 30분, 40분, 50분에 센서를 측정해서 저장합니다.
        </p>
        <b-form @submit.stop.prevent class="m-3">

            <b-form-group class="mb-3">
            <b-form-checkbox v-model="configSleepSaveUse" id="configSleepSaveUse" switch size="sm" class="fontSizeDot9">사용</b-form-checkbox>
            </b-form-group>

            <b-form-group v-slot="{ ariaDescribedby }" class="mb-4">
            <b-form-checkbox-group v-model="configSleepSaveWeekSelected" :options="configSleepSaveWeekOptions"
                :aria-describedby="ariaDescribedby" plain :disabled="configSleepSaveUse != '1'" class="fontSizeDot9"></b-form-checkbox-group>
            <div class="text-right">
                <b-button size="sm" :disabled="configSleepSaveUse != '1'" class="pl-2 pr-2 pt-dot1 pb-dot1 mr-2 fontSizeDot8" @click="checkAll(configSleepSaveWeekOptions, 'configSleepSaveWeekSelected')">모두 선택</b-button>
                <b-button size="sm" :disabled="configSleepSaveUse != '1'" class="pl-2 pr-2 pt-dot1 pb-dot1 mr-2 fontSizeDot8" @click="uncheckAll('configSleepSaveWeekSelected')">선택 취소</b-button>
            </div>
            </b-form-group>

            <b-form-group v-slot="{ ariaDescribedby }">
            <b-form-checkbox-group v-model="configSleepSaveHoursSelected" :options="configSleepSaveHoursOptions"
                :aria-describedby="ariaDescribedby" plain :disabled="configSleepSaveUse != '1'" class="fontSizeDot9"></b-form-checkbox-group>
            <div class="text-right">
                <b-button size="sm" :disabled="configSleepSaveUse != '1'" class="pl-2 pr-2 pt-dot1 pb-dot1 mr-2 fontSizeDot8"  @click="checkAll(configSleepSaveHoursOptions, 'configSleepSaveHoursSelected')">모두 선택</b-button>
                <b-button size="sm" :disabled="configSleepSaveUse != '1'" class="pl-2 pr-2 pt-dot1 pb-dot1 mr-2 fontSizeDot8" @click="uncheckAll('configSleepSaveHoursSelected')">선택 취소</b-button>
            </div>
            </b-form-group>
        </b-form>

        <template slot="modal-footer">
            <b-button variant="primary" size="sm" @click="hideModal('configSleepSaveFloat')">
            닫기
            </b-button>
        </template>

        </b-modal>

        <b-modal v-touch:swipe.stop v-if="!pageDevice.disabled" size="lg" id="configSleepUpdateFloat"
        tabindex="-1" title="SLEEP 업데이트 요일과 시간 설정" static
        @show="modalShowFocus" data-nextfocus="configSleepUpdateUse" header-bg-variant="primary" header-text-variant="light" footer-bg-variant="light" footer-text-variant="primary" header-class="pt-2 pb-2 pr-3 pl-3" footer-class="pt-1 pb-1 pr-3 pl-3" content-class="border-0" button-size="sm">

        <p class="mb-1 fontSizeDot9 gothic">
            Sleep 모드에서 특정 요일, 시간에 데이터를 서버로 업로드할 수 있습니다. 여기서 지정한 요일과 시간은 Config Sleep Save 설정에서도 동일한 요일, 시간이 선택된 경우에만 동작합니다. Update Interval 설정으로 지정한 시간대에서 언제 데이터를 업로드할 지도 지정할 수 있습니다.
        </p>
        <b-form @submit.stop.prevent class="m-3">

            <b-form-group class="mb-3">
            <b-form-checkbox v-model="configSleepUpdateUse" id="configSleepUpdateUse" class="fontSizeDot9" switch size="sm">사용</b-form-checkbox>
            </b-form-group>

            <b-form-group v-slot="{ ariaDescribedby }" class="mb-4">
            <b-form-checkbox-group v-model="configSleepUpdateWeekSelected" :options="configSleepUpdateWeekOptions" :aria-describedby="ariaDescribedby" plain :disabled="configSleepUpdateUse != '1'" class="fontSizeDot9"></b-form-checkbox-group>
            <div class="text-right">
                <b-button size="sm" :disabled="configSleepUpdateUse != '1'" class="pl-2 pr-2 pt-dot1 pb-dot1 mr-2 fontSizeDot8" @click="checkAll(configSleepUpdateWeekOptions, 'configSleepUpdateWeekSelected')">모두 선택</b-button>
                <b-button size="sm" :disabled="configSleepUpdateUse != '1'" class="pl-2 pr-2 pt-dot1 pb-dot1 mr-2 fontSizeDot8" @click="uncheckAll('configSleepUpdateWeekSelected')">선택 취소</b-button>
            </div>
            </b-form-group>

            <b-form-group v-slot="{ ariaDescribedby }">
            <b-form-checkbox-group v-model="configSleepUpdateHoursSelected" :options="configSleepUpdateHoursOptions" class="fontSizeDot9"
                :aria-describedby="ariaDescribedby" plain :disabled="configSleepUpdateUse != '1'"></b-form-checkbox-group>
            <div class="text-right">
                <b-button size="sm" :disabled="configSleepUpdateUse != '1'" class="pl-2 pr-2 pt-dot1 pb-dot1 mr-2 fontSizeDot8" @click="checkAll(configSleepUpdateHoursOptions, 'configSleepUpdateHoursSelected')">모두 선택</b-button>
                <b-button size="sm" :disabled="configSleepUpdateUse != '1'" class="pl-2 pr-2 pt-dot1 pb-dot1 mr-2 fontSizeDot8" @click="uncheckAll('configSleepUpdateHoursSelected')">선택 취소</b-button>
            </div>
            </b-form-group>
        </b-form>

        <template slot="modal-footer">
            <b-button variant="primary" size="sm" @click="hideModal('configSleepUpdateFloat')">
            닫기
            </b-button>
        </template>

        </b-modal>

    </div>

</template>
<script>
    import firebase from "firebase/app";
    import "firebase/auth";
    import "firebase/firestore";
    import { db } from "@/plugins/firebase.js"

    import uiUtil from "@/mixins/util.js"
    import mapUtil from "@/mixins/mapUtil.js"
    import user from "@/mixins/user.js"

    import { cloneDeep } from "lodash";

    import deviceTabs from "@/components/device/deviceTabs.vue"
    import configStatusInputList from "@/components/common/configStatusInputList.json"

    export default {
        name: "deviceConfig",
        mixins: [uiUtil, mapUtil, user],
        props: {
            pageUser: {
              type: Object,
              default: null
            },
            pageDevice: {
              type: Object,
              default: null
            },
            pageBinded: {
              type: Boolean,
              default: false
            },
            action: {
              type: String,
              default: ""
            }
        },
        components: {
            deviceTabs,
        },
        data: function() {
            return {

                showSetWifiAction: false,
                setWifiFinished: false,

                sendCommandDisabled: false,

                consoleAutoScroll: true,
                consoleRowHeight: 300,
                consoleContent: "",
                consoleContentTemp: "",

                contentToWrite: "",
                contentWritten: "",
                selectedCommand: "",
                selectedConfigAttrName: "속성 이름",
                selectedConfigAttrText: "",
                selectedConfigAttrValueRule: "",
                selectedConfigAttrValue: "",

                selectedCommandOperandSSID: "",
                selectedCommandOperandPassword: "",
                selectedCommandOperandTime: "",
                selectedCommandOperandFilePath: "",
                selectedCommandOperandFileContent: "",
                
                selectedCommandOperandSensorName: "",
                selectedCommandOperandSensorType: "",
                selectedCommandOperandSensorTypeText: "센서 종류",
                selectedCommandOperandSensorTypeDesc: "",
                
                selectedCommandOperandSensorReadInterval: "",
                selectedCommandOperandSensorUpdateInterval: "",
                selectedCommandOperandSensorOpt1: "",
                selectedCommandOperandSensorOpt2: "",

                serialPort: null,
                serialPortWriter: null,
                serialPortReader: null,

                textDecoder: null,
                textEncoder: null,

                deviceInfoJson: null,
                deviceInfoJsonSSID: "",
                deviceInfoJsonPassword: "",
                deviceDid: "",

                deviceConfigJson: null,
                deviceConfigJsonUpdateNeed: false,
                deviceConfigJsonOriginal: null,

                week: ["일", "월", "화", "수", "목", "금", "토"],

                configStatusInputList: configStatusInputList,
                showconfigStatusInputList: false,

                configRebootUse: true,
                configRebootWeekSelected: [],
                configRebootWeekOptions: [],
                configRebootHoursSelected: [],
                configRebootHoursOptions: [],

                configSleepSaveUse: true,
                configSleepSaveWeekSelected: [],
                configSleepSaveWeekOptions: [],
                configSleepSaveHoursSelected: [],
                configSleepSaveHoursOptions: [],

                configSleepUpdateUse: true,
                configSleepUpdateWeekSelected: [],
                configSleepUpdateWeekOptions: [],
                configSleepUpdateHoursSelected: [],
                configSleepUpdateHoursOptions: [],

                deviceWifiJson: null,
                deviceWifiJsonPooled: false,
                deviceWifiJsonUpdateNeed: false,
                deviceWifiJsonMerged: null,
                deviceWifiJsonNewSSID: "",
                deviceWifiJsonNewPassword: "",

                // deviceSensorsInfoJson: null,

                deviceSensorsJson: null,
                deviceSensorsJsonMerged: null,
                deviceSensorsJsonUpdateNeed: false,

                useSerialPortFilter: true,
                serialBaudRate: "",
                serialType: "",
                connectedSerialInfo: "연결 끊어짐",
                usbVendorId: null,
                usbProductId: null,

                valueType: {
                    "BOOL_VAL":2,
                    "INT_VAL":3,
                    "UNSIGNED_INT_VAL":4,
                    "LONG_VAL":5,
                    "UNSIGNED_LONG_VAL":6,
                    "FLOAT_VAL":7
                },

                valueTypeByIndex: [
                    "",
                    "",
                    "BOOL_VAL",
                    "INT_VAL",
                    "UNSIGNED_INT_VAL",
                    "LONG_VAL",
                    "UNSIGNED_LONG_VAL",
                    "FLOAT_VAL"
                ],

                sensorType: {
                    "CUSTOM": 2,
                    "BME280": 3,
                    "BH1750": 4,
                    "DIGITAL": 5,
                    "BUTTON": 6,
                    "S8": 7,
                    "PMS": 8,
                    "ANALOG": 9,
                    "INA219": 10,
                    "DHT22": 11,
                    "TCS34725": 12,
                    "BMP280": 13,
                    "BME680": 14,
                    "PMSST": 15,
                    "CCS811": 16,
                    "INA3221": 17,
                    "VEML6070": 18,
                    "MAX30100": 19,
                    "MPU6050": 20,
                    "MAX4466": 21,
                    "LM393": 22,
                    "VL53L0X": 23,
                    "PMSF": 24,
                    "PMSTF": 25,
                },

                sensorCompareList: [
                    { name: "re", title: "읽기 간격" },
                    { name: "up", title: "업데이트 간격" },
                    { name: "ad", title: "I2C 주소" },
                    { name: "pi", title: "핀" },
                    { name: "rx", title: "RX 핀" },
                    { name: "tx", title: "TX 핀" },
                ],

                sensorCompareValueList: [
                    { name: "un", title: "단위" },
                    { name: "hi", title: "숨김" },
                    { name: "ho", title: "전송안함" },
                    { name: "ma", title: "최댓값" },
                    { name: "mi", title: "최솟값" },
                    { name: "di", title: "차이값" },
                ],


                sensorTypeByIndex: [
                    "",
                    "",
                    "CUSTOM",
                    "BME280",
                    "BH1750",
                    "DIGITAL",
                    "BUTTON",
                    "S8",
                    "PMS",
                    "ANALOG",
                    "INA219",
                    "DHT22",
                    "TCS34725",
                    "BMP280",
                    "BME680",
                    "PMSST",
                    "CCS811",
                    "INA3221",
                    "VEML6070",
                    "MAX30100",
                    "MPU6050",
                    "MAX4466",
                    "LM393",
                    "VL53L0X",
                    "PMSF",
                    "PMSTF",
                ],

                reList: [
                    {"action": "reboot", "re": /\[info\] doLoop: setup finished.\r?\n/ },
                    {"action": "downConfig", "re": /\[info\] poolConfigJson: received Config Json File.\r?\n/ },
                    {"action": "downSensors", "re": /\[info\] poolSensorsJson: received Sensors Json File.\r?\n/ },
                    {"action": "downWifi", "re": /\[info\] poolWifiJson: received Wifi Json File.\r?\n/ },
                    {"action": "commandReceived", "re": /1 Received.([^\n]*)/ },
                    {"action": "commandError", "re": /0 Error.([^\n]*)/ },
                    {"action": "jsonObject", "re": /(\/info\/info\.json|\/re\/info\.json|\/config\.json): ({[^}]+})\r?\n/ },
                    {"action": "jsonArray", "re": /(\/wifi\.json|\/sensors\.json): (\[.+\])\r?\n/ },
                    {"action": "connectWifiInsideDoLoop", "re": /\[info\] doAfterWifiConnected: WiFi Connected inside doLoop.\r?\n/ },
                    {"action": "disconnectWifi", "re": /\[info\] wifiOnDisconnectedCallback: Wifi Disconnected.\r?\n/ },
                ],

                sensorTypeList : [
                    { "name": "CUSTOM", "value" : 2, "desc": "커스텀 센서" },
                    { "name": "BME280", "value" : 3, "desc": "온도/습도/기압 센서" },
                    { "name": "BH1750", "value" : 4, "desc": "조도 센서" },
                    { "name": "DIGITAL", "value" : 5, "desc": "디지털 센서" },
                    { "name": "BUTTON", "value" : 6, "desc": "버튼 센서" },
                    { "name": "S8", "value" : 7, "desc": "CO2 센서" },
                    { "name": "PMS", "value" : 8, "desc": "미세먼지 센서" },
                    { "name": "ANALOG", "value" : 9, "desc": "아날로그 센서" },
                    { "name": "INA219", "value" : 10, "desc": "전류/전압 센서" },
                    { "name": "TCS34725", "value" : 12, "desc": "색깔 센서" },
                    { "name": "BME680", "value" : 14, "desc": "온도/습도/기압/공기질 센서" },
                    { "name": "PMSST", "value" : 15, "desc": "미세먼지/포름알데히드 센서" },
                    { "name": "VEML6070", "value" : 18, "desc": "자외선 센서" },
                    { "name": "PMSF", "value" : 24, "desc": "미세먼지 센서(모든 값)" },
                    { "name": "PMSTF", "value" : 25, "desc": "미세먼지/포름알데히드 센서(모든 값)" }
                ],

                configList: [
                    {name: "ve", text: "설정 버전", valueRule:"정수를 입력해야합니다." },
                    {name: "ss", text: "SSID 이름", valueRule:"최대 32글자로 숫자로 시작하면 안되고, 한글, 특수문자, 공백은 사용할 수 없습니다." },
                    {name: "pw", text: "WiFi 비밀번호", valueRule:"최대 32글자로 숫자로 시작하면 안되고, 한글, 특수문자, 공백은 사용할 수 없습니다." },
                    {name: "ac", text: "접속 코드", valueRule:"20글자로 문자 또는 숫자입니다." },
                    {name: "id", text: "WiFi ID", valueRule:"[지원 예정] 엔터프라이즈 WiFi에 사용하는 ID입니다. 최대 32글자로 숫자로 시작하면 안되고, 한글, 특수문자, 공백은 사용할 수 없습니다." },
                    {name: "wt", text: "WiFi 타입", valueRule:"[지원 예정] WiFi 타입을 나타내는 숫자. WEP는 2, WPA Personal은 3, WPA Enterprise는 4입니다. 대부분의 공유기는 WPA Personal로 동작합니다." },
                    {name: "wi", text: "WiFi 체크 간격", valueRule:"WiFi가 연결이 되지 않은 경우에 WiFi 연결을 시도할 간격. 단위는 1/1000초입니다. 최솟값은 180000(3분), 최댓값은 86400000(1일)입니다." },
                    {name: "ui", text: "업데이트/저장 간격", valueRule:"데이터 업데이트/저장 간격. 단위는 1/1000초입니다. 최솟값은 60000(1분), 최댓값은 86400000(1일)입니다." },
                    {name: "st", text: "설정 속성", valueRule:"32개의 0 또는 1. 각각의 숫자가 다양한 설정입니다. 자세한 내용은 기기설정의 상세설정 참고하세요."},
                    {name: "sr", text: "슬립 읽기 지연", valueRule:"슬립 기능 사용할 때 켜진 후에 읽기 지연 시간입니다. 단위는 1/1000초입니다. 최솟값은 5000(5초), 최댓값은 300000(5분)입니다." },
                    {name: "si", text: "슬립 간격", valueRule:"슬립 기능 사용할 때 슬립 간격입니다. 기기 슬립 오차로 실제 슬립 시간은 이 간격보다 짧고 보정 기능이 들어가 있습니다. 단위는 1/1000초입니다. 최솟값은 300000(5분), 최댓값은 10800000(3시간)입니다." },
                    {name: "sl", text: "슬립 읽기 시간", valueRule:"32개의 0 또는 1. 맨처음은 사용여부, 2번째부터 8번째까지는 일~토요일, 9번째부터 32번째는 0시~24시입니다."},
                    {name: "su", text: "슬립 업데이트 시간", valueRule:"32개의 0 또는 1. 맨처음은 사용여부, 2번째부터 8번째까지는 일~토요일, 9번째부터 32번째는 0시~24시입니다."},
                    {name: "ip", text: "WiFi IP 주소", valueRule:"255.255.255.255와 같은 형식입니다."},
                    {name: "sm", text: "WiFi 서브넷마크스크", valueRule:"255.255.255.255와 같은 형식입니다."},
                    {name: "ga", text: "WiFi 게이트웨이", valueRule:"255.255.255.255와 같은 형식입니다."},
                    {name: "dn", text: "WiFi DNS", valueRule:"255.255.255.255와 같은 형식입니다."}
                ],
            }
        },

        mounted: function() {

            if(this.action == "setWifi") {
                this.showSetWifiAction = true;
            }

            this.textDecoder = new TextDecoder();
            this.textEncoder = new TextEncoder();
            this.disconnectSerialPort();
        },

        beforeDestroy: function() {
            this.disconnectSerialPort();
        },

        /*
        http://www.linux-usb.org/usb.ids
        1a86  QinHeng Electronics
	        7522  CH340 serial converter
	        7523  CH340 serial converter *
        10c4  Silicon Labs
	        ea60  CP210x UART Bridge *
	        ea61  CP210x UART Bridge
	        ea63  CP210x UART Bridge
        */        

        methods: {

            getDidByAcode: function() {
                if(this.deviceInfoJson != null && typeof(this.deviceInfoJson.ac) != "undefined" && this.deviceInfoJson.ac != "") {
                    db.collection("acodes").doc(this.deviceInfoJson.ac)
                    .get()
                    .then(acode => {
                        if(acode.exists) {
                            this.deviceDid = acode.data().device;
                        }
                    })
                    .catch(error => {
                        this.makeToast("danger", "기기 ID 조회 실패", "기기 ID 조회 실패. 에러 내용:" + error)
                    })
                }
            },

            clearActionAndHideModal: function() {
              this.$router.push({path: "/d/" + this.pageDevice.id + "?mode=serial&action="})
              window.setTimeout(()=> {
                  this.hideModal("setWifiAction");
              }, 100);
            },

            initDeviceConfigEditEnvironment: function() {

                this.deviceConfigJsonOriginal = cloneDeep(this.deviceConfigJson);

                if(this.deviceConfigJson.rb) {
                    let configRebootList = this.deviceConfigJson.rb.padStart(32, '0').split("");

                    configRebootList.forEach((item,index) => {
                        if(index == 0) {
                            this.configRebootUse = (item == "0")? false: true;
                        }
                        else if(index <8) {
                            this.configRebootWeekOptions.push({ text: this.week[index-1], value: index });
                            if(item == "1") {
                                this.configRebootWeekSelected.push(index);
                            }
                        }
                        else {
                            this.configRebootHoursOptions.push({ text: (index-8) + "시", value: index });
                            if(item == "1") {
                                this.configRebootHoursSelected.push(index);
                            }
                        }
                    });
                }


                if(this.deviceConfigJson.sl) {
                    let configSleepSaveList = this.deviceConfigJson.sl.padStart(32, '0').split("");

                    configSleepSaveList.forEach((item,index) => {
                        if(index == 0) {
                            this.configSleepSaveUse = (item == "0")? false: true;
                        }
                        else if(index <8) {
                            this.configSleepSaveWeekOptions.push({ text: this.week[index-1], value: index });
                            if(item == "1") {
                                this.configSleepSaveWeekSelected.push(index);
                            }
                        }
                        else {
                            this.configSleepSaveHoursOptions.push({ text: (index-8) + "시", value: index });
                            if(item == "1") {
                                this.configSleepSaveHoursSelected.push(index);
                            }
                        }
                    });
                }

                if(this.deviceConfigJson.su) {
                    let configSleepUpdateList = this.deviceConfigJson.su.padStart(32, "0").split("");

                    configSleepUpdateList.forEach((item,index) => {
                        if(index == 0) {
                            this.configSleepUpdateUse = (item == "0")? false: true;
                        }
                        else if(index <8) {
                            this.configSleepUpdateWeekOptions.push({ text: this.week[index-1], value: index });
                            if(item == "1") {
                                this.configSleepUpdateWeekSelected.push(index);
                            }
                        }
                        else {
                            this.configSleepUpdateHoursOptions.push({ text: (index-8) + "시", value: index });
                            if(item == "1") {
                                this.configSleepUpdateHoursSelected.push(index);
                            }
                        }
                    });
                }

                if(this.deviceConfigJson.st && this.pageDevice.config.st) {
                    let deviceConfigStatusValues = this.deviceConfigJson.st.padStart(32, '0').split("");
                    let pageDeviceConfigStatusValues = (typeof(this.pageDevice.config) != 'undefined')? this.pageDevice.config.st.padStart(32, '0').split("") : [];

                    this.configStatusInputList.forEach(item => {
                        if(item.pos < deviceConfigStatusValues.length) {
                            item.value = deviceConfigStatusValues[item.pos];
                            item.originalValue = item.value;
                        }
                        if(item.pos < pageDeviceConfigStatusValues.length) {
                            item.__value = pageDeviceConfigStatusValues[item.pos];
                        }
                    });
                }
            },
            saveConfig: function() {
                if(this.isSameMacAddress) {
                    this.deviceConfigJson.sl = this.configSleepSaveBinary;
                    this.deviceConfigJson.su = this.configSleepUpdateBinary;
                    this.deviceConfigJson.rb = this.configRebootBinary;
                    this.deviceConfigJson.st = this.configStatusBinary;

                    db.collection("devices").doc(this.pageDevice.id).update({
                        "config": this.deviceConfigJson
                    })
                    .then(()=>{
                        this.sendCommand("downConfig");
                        this.initDeviceConfigEditEnvironment();
                    })
                    .catch(error => {
                        this.makeToast("danger", "[" + this.pageDevice.name + "] 기기 설정 수정 실패", "다음과 같은 에러가 발생했습니다.\n에러 내용:" + error.message, { autoHideDelay: 10000 })
                    })
                    // this.deviceConfigJson
                }

            },
            sendUpSensors: function() {
                this.deviceSensorsJsonMerged = this.mergeArrayOfObjectsByKey(this.deviceSensorsJson, this.deviceSensorsJson, "na", "__", false);
                this.sendCommand("upSensors");
            },
            sendDownSensors: function() {
                this.deviceSensorsJsonUpdateNeed = true;
                this.sendCommand("downSensors");
            },
            sendUpConfig: function() {
                this.sendCommand("upConfig");
            },
            sendDownConfig: function() {
                this.deviceConfigJsonUpdateNeed = true;
                this.sendCommand("downConfig");
            },

            configClass: function(val, deviceVal, serverVal) {
                if(val == deviceVal) {
                    if(this.isSameMacAddress) {
                        if(val == serverVal) {
                            return "text-black bg-white";
                        }

                        else {
                            return "text-danger bg-danger-light";
                        }
                    }
                    else {
                        return "text-black bg-white";
                    }
                }
                else {
                    if(this.isSameMacAddress) {
                        if(val == serverVal) {
                            return "text-primary bg-blue-light";
                        }
                        else {
                            return "text-danger bg-danger-light";
                        }
                    }
                    else {
                        return "text-danger bg-danger-light";
                    }
                }
            },

            configTitle: function(val, deviceVal, serverVal) {
                if(val == deviceVal) {
                    if(this.isSameMacAddress && val == serverVal) {
                        return "모두 일치";
                    }
                    else {
                        if(this.isSameMacAddress) {
                            return "수정 없음. 일치안함. 서버 값: " + serverVal;
                        }
                        else {
                            return "수정 없음.";
                        }
                    }
                }
                else {
                    if(this.isSameMacAddress && val == serverVal) {
                        return "수정됨. 서버 값과 일치. 기기 원래값: " + deviceVal;
                    }
                    else if(this.isSameMacAddress && deviceVal == serverVal) {
                        return "수정됨. 기기 원래값/서버 값: " + deviceVal;
                    }
                    else if(this.isSameMacAddress) {
                        return "수정됨. 기기 원래값: " + deviceVal + ", 서버 값: " + serverVal;
                    }
                    else {
                        return "수정됨. 기기 원래값: " + deviceVal;
                    }
                }
            },
            checkAll: function(list, selected) {
                var newSelected = [];
                list.forEach(item=> {
                    newSelected.push(item.value);
                })
                this.$set(this, selected, newSelected);
            },
            uncheckAll: function(selected) {
                this.$set(this, selected, []);
            },
            sendUpWifi: function() {
                this.sendCommand('upWifi');
                this.deviceWifiJsonMerged = this.mergeArrayOfObjectsByKey(this.deviceWifiJson, this.deviceWifiJson, "s", "__", false);
            },
            sendDownWifi: function() {
                this.deviceWifiJsonUpdateNeed = true;
                this.sendCommand('downWifi');
            },
            removeWifi: function() {
                this.sendCommand('remove /wifi.json');
                if(this.isSameMacAddress) {
                    db.collection("devices").doc(this.pageDevice.id).update({
                        "wifi": []
                    });
                }
                this.deviceWifiJson = [];
                this.deviceWifiJsonMerged = {};
            },
            openFloat: function(floatName) {
                this.$bvModal.show(floatName);
            },
            sendConnectWifi: function() {
                this.sendCommand('connectWifi');
            },
            sendReboot: function() {
                this.sendCommand('reboot');
            },
            sendInfo: function() {
                this.sendCommand('info');
            },
            showConfigDeviceWifiFloat: function() {
                this.sendCommand('print /wifi.json');
                this.deviceWifiJsonPooled = true;
                this.$bvModal.show("configDeviceWifiFloat");
            },
            showConfigDeviceConfigFloat: function() {
                this.sendCommand('print /config.json');
                this.$bvModal.show("configDeviceConfigFloat");
            },
            showConfigDeviceSensorsFloat: function() {
                this.sendCommand('print /sensors.json');
                this.$bvModal.show("configDeviceSensorsFloat");
            },
            sendSetWifi: function() {
                if(this.deviceInfoJsonSSID != '') {
                    if(this.isSameMacAddress && this.isPageDeviceConfigExist) {
                        db.collection("devices").doc(this.pageDevice.id).update({
                            "config.ss": this.deviceInfoJsonSSID,
                            "config.pw": this.deviceInfoJsonPassword
                        });
                    }
                    this.deviceInfoJson.ss = this.deviceInfoJsonSSID;
                    this.deviceInfoJson.pw = this.deviceInfoJsonPassword;
                    this.sendCommand(("setWifi " + this.deviceInfoJsonSSID + " " + this.deviceInfoJsonPassword).trim());
                }    
            },
            sendAddWifi: async function() {
                if(this.deviceWifiJsonNewSSID != '') {
                    this.sendCommand(("addWifi " + this.deviceWifiJsonNewSSID + " " + this.deviceWifiJsonNewPassword).trim());
                    if(this.deviceWifiJsonNewPassword != "") {
                        this.deviceWifiJson.push({"s": this.deviceWifiJsonNewSSID, "p": this.deviceWifiJsonNewPassword });
                    }
                    else {
                        this.deviceWifiJson.push({"s": this.deviceWifiJsonNewSSID});
                    }
                    if(this.isSameMacAddress) {
                        let toAdd = {};
                        toAdd.s = this.deviceWifiJsonNewSSID;
                        if(this.deviceWifiJsonNewPassword != "") toAdd.p = this.deviceWifiJsonNewPassword;

                        if(typeof(this.pageDevice.wifi) == 'undefined') {
                            await db.collection("devices").doc(this.pageDevice.id).update({
                                "wifi": [ toAdd ]
                            });

                        }
                        else {
                            await db.collection("devices").doc(this.pageDevice.id).update({
                                "wifi": firebase.firestore.FieldValue.arrayUnion(toAdd)
                            });
                        }
                        this.deviceWifiJsonMerged = this.mergeArrayOfObjectsByKey(this.deviceWifiJson, this.pageDevice.wifi, "s", "__", false);
                    }
                    else {
                        this.deviceWifiJsonMerged = this.mergeArrayOfObjectsByKey(this.deviceWifiJson, [], "s", "__", false);
                    }
                    this.deviceWifiJsonNewSSID = "";
                    this.deviceWifiJsonNewPassword = "";
                }    
            },
            applyPageDeviceSSID: function() {
                this.deviceInfoJsonSSID = this.pageDevice.config.ss;
            },
            applyPageDevicePassword: function() {
                this.deviceInfoJsonPassword = this.pageDevice.config.pw;
            },

            selectSensorType: function(name, value, desc) {
                this.selectedCommandOperandSensorType = value;
                this.selectedCommandOperandSensorTypeText = name;
                this.selectedCommandOperandSensorTypeDesc = desc;
            },

            makeContentToWrite: function() {
                if(this.selectedCommand == "config") {
                    this.contentToWrite = (this.selectedCommand + " " + this.selectedConfigAttrName + " " + this.selectedConfigAttrValue).trim();
                }
                else if(["setWifi", "addWifi"].includes(this.selectedCommand)) {
                    this.contentToWrite = (this.selectedCommand + " " + this.selectedCommandOperandSSID + " " + this.selectedCommandOperandPassword).trim();
                }
                else if(this.selectedCommand == "setTime") {
                    this.contentToWrite = (this.selectedCommand + " " + this.selectedCommandOperandTime).trim();
                }
                else if(this.selectedCommand == "create") {
                    this.contentToWrite = (this.selectedCommand + " " + this.selectedCommandOperandFilePath + " " + this.selectedCommandOperandFileContent).trim();
                }
                else if(this.selectedCommand == "addSensor") {
                    this.contentToWrite = (this.selectedCommand + " " + this.selectedCommandOperandSensorName + " " + this.selectedCommandOperandSensorType + " " + this.selectedCommandOperandSensorReadInterval+ " " + this.selectedCommandOperandSensorUpdateInterval+ " " + this.selectedCommandOperandSensorOpt1+ " " + this.selectedCommandOperandSensorOpt2).trim();
                }
                else if(["print", "remove"].includes(this.selectedCommand)) {
                    this.contentToWrite = (this.selectedCommand + " " + this.selectedCommandOperandFilePath).trim();
                }
                else if(["read", "save"].includes(this.selectedCommand)) {
                    this.contentToWrite = (this.selectedCommand + " " + this.selectedCommandOperandSensorName).trim();
                }
                else {
                    this.contentToWrite = this.selectedCommand;
                }
            },
            selectConfigAttr: function(name, text, valueRule) {
                this.selectedConfigAttrName = name;
                this.selectedConfigAttrText = text;
                this.selectedConfigAttrValueRule = valueRule;
                this.selectedConfigAttrValue = "abcd";
                if(typeof(this.pageDevice.config) != 'undefined' && typeof(this.pageDevice.config[name]) != "undefined") {
                    this.selectedConfigAttrValue = this.pageDevice.config[name];
                }
                else {
                    this.selectedConfigAttrValue = this.pageDevice.config[name];
                }
            },
            selectCommand: function(command) {
                this.contentToWrite = "";
                this.selectedCommand = command;
                if(command == "config") {
                    this.selectedConfigAttrName = "속성 이름";
                }
                else if(this.selectedCommand == "setWifi") {
                    if(typeof(this.pageDevice.config) != 'undefined' && typeof(this.pageDevice.config['ss']) != "undefined") {
                        this.selectedCommandOperandSSID = this.pageDevice.config['ss'];
                    }
                    else {
                        this.selectedCommandOperandSSID = "";
                    }
                    if(typeof(this.pageDevice.config) != 'undefined' && typeof(this.pageDevice.config['pw']) != "undefined") {
                        this.selectedCommandOperandPassword = this.pageDevice.config['pw'];
                    }
                    else {
                        this.selectedCommandOperandPassword = "";
                    }
                }
                else if(this.selectedCommand == "addWifi") {
                    this.selectedCommandOperandSSID = "";
                    this.selectedCommandOperandPassword = "";
                }
                else if(this.selectedCommand == "setTime") {
                    this.selectedCommandOperandTime = this.dateToString(new Date(), "-", " ", ":");
                }
                else if(this.selectedCommand == "addSensor") {
                    this.selectedCommandOperandSensorType = "";
                    this.selectedCommandOperandSensorName = "";
                    this.selectedCommandOperandSensorTypeText = "센서 종류";
                    this.selectedCommandOperandSensorTypeDesc = "";
                    this.selectedCommandOperandSensorUpdateInterval = "";
                    this.selectedCommandOperandSensorOpt1 = "";
                    this.selectedCommandOperandSensorReadInterval = "";
                    this.selectedCommandOperandSensorOpt2 = "";
                }
                else if(["remove", "create", "print"].includes(this.selectedCommand)) {
                    this.selectedCommandOperandFilePath = "";
                    this.selectedCommandOperandFileContent = "";
                }
                this.contentToWrite = command;
            },
            toggleConsoleAutoScroll: function() {
                this.consoleAutoScroll = !this.consoleAutoScroll;
            },
            copyConsole: function() {
              this.$copyText(this.$refs.consoleContent.innerText);
            },
            clearConsole: function() {
                this.consoleContent = "";
            },
            enlargeConsoleHeight: function() {
                this.consoleRowHeight = this.consoleRowHeight + 100;
            },
            reduceConsoleHeight: function() {
                this.consoleRowHeight = Math.max(200, this.consoleRowHeight - 100);
            },
            toggleUseSerialPortFilter: function() {
                this.useSerialPortFilter = !this.useSerialPortFilter;
            },

            readFromSerial: function(content) {
                if(this.consoleContent.length > 1000000) {
                    this.consoleContent = "";
                }
                this.consoleContentTemp += content;
                if(this.consoleContentTemp.charAt(this.consoleContentTemp.length-1) == "\n") {
                    let regResult = null;

                    this.consoleContent += this.consoleContentTemp;
                    for(let i=0;i<this.reList.length;i++) {
                        regResult = this.reList[i].re.exec(this.consoleContentTemp);
                        console.log(regResult);
                        if(regResult != null) {
                            if(this.reList[i].action != null) {
                                if(this.reList[i].action == "reboot") {
                                    this.makeToast("success", "연결된 기기 켜짐", "연결된 기기가 켜졌습니다. 센서 데이터 업데이트 후에 기기 정보를 읽어옵니다.", { autoHideDelay: 10000 });
                                    this.consoleContent += "\r\n<span class='text-info font-weight-bold'>연결된 기기가 켜졌고 설정을 완료 했습니다.</span>\r\n";
                                    this.deviceInfoJson = null;
                                    this.deviceDid = "";
                                    this.deviceSensorsJsonNotExist = false;
                                    this.deviceConfigsonNotExist = false;
                                    this.$bvModal.hide("configDeviceWifiFloat");
                                    this.$bvModal.hide("configDeviceConfigFloat");
                                    this.$bvModal.hide("configDeviceSensorsFloat");
                                    this.sendCommand("info");
                                }
                                else if(this.reList[i].action == "downConfig") {
                                    if(this.deviceConfigJsonUpdateNeed) {
                                        this.deviceConfigJsonUpdateNeed = false;
                                        if(this.isSameMacAddress) {
                                            this.deviceConfigJson = cloneDeep(this.pageDevice.config);
                                            this.initDeviceConfigEditEnvironment();
                                        }
                                        else {
                                            this.sendCommand('print /config.json');
                                        }
                                    }
                                }
                                else if(this.reList[i].action == "downWifi") {
                                    if(this.deviceWifiJsonUpdateNeed) {
                                        this.deviceWifiJsonUpdateNeed = false;
                                        if(this.isSameMacAddress) {
                                            this.deviceWifiJson = cloneDeep(this.pageDevice.wifi);
                                            this.deviceWifiJsonMerged = this.mergeArrayOfObjectsByKey(this.deviceWifiJson, this.pageDevice.wifi, "s", "__", false);
                                        }
                                        else {
                                            this.sendCommand('print /wifi.json');
                                        }
                                    }
                                }
                                else if(this.reList[i].action == "downSensors") {
                                    if(this.deviceSensorsJsonUpdateNeed) {
                                        this.deviceSensorsJsonUpdateNeed = false;
                                        if(this.isSameMacAddress) {
                                            this.deviceSensorsJson = cloneDeep(this.sensorsJsonSource);
                                            this.deviceSensorsJsonMerged = this.mergeArrayOfObjectsByKey(this.deviceSensorsJson, this.sensorsJsonSource, "na", "__", false);
                                        }
                                        else {
                                            this.sendCommand('print /sensors.json');
                                        }
                                    }
                                }
                                else if(this.reList[i].action == "commandReceived") {

                                    if(this.contentWritten == "reboot") {
                                        this.makeToast("success", "Reboot 명령 실행 성공", "약 5초 뒤에 기기가 리부팅됩니다. 기기가 켜지면 서버와 동기화 작업이 진행되므로 완전히 켜지기까지 시간이 오래 걸릴 수 있으니 기다려 주시기 바랍니다. " + regResult[1].trim(), { autoHideDelay: 10000 });
                                    }
                                    else if(this.contentWritten.startsWith("setWifi ")) {
                                        this.setWifiFinished = true;
                                        this.makeToast("success", "명령 실행 성공", this.contentWritten + " 실행 성공했습니다. " + regResult[1].trim(), { autoHideDelay: 10000 });
                                    }
                                    else {
                                        this.makeToast("success", "명령 실행 성공", this.contentWritten + " 실행 성공했습니다. " + regResult[1].trim(), { autoHideDelay: 10000 });
                                    }

                                    this.consoleContent += "\r\n<span class='text-info font-weight-bold'>" + this.contentWritten + " 실행 성공: " + regResult[1] + "</span>\r\n";

                                    
                                }
                                else if(this.reList[i].action == "commandError") {
                                    if(regResult[1].trim() == "Can't print. File doesn't exist. filename=/wifi.json") {
                                        this.deviceWifiJson = [];
                                        if(typeof(this.pageDevice.wifi) == "undefined") {
                                            this.pageDevice.wifi = [];
                                        }
                                        this.deviceWifiJsonMerged = this.mergeArrayOfObjectsByKey(this.deviceWifiJson, this.pageDevice.wifi, "s", "__", false);
                                    }

                                    if(!this.showSetWifiAction) {
                                        this.makeToast("danger", "명령 실행 에러", this.contentWritten + " 실행 결과 에러가 발생했습니다. " + regResult[1].trim(), { autoHideDelay: 10000 });
                                    }

                                    this.consoleContent += "\r\n<span class='text-info font-weight-bold'>" + this.contentWritten + " 실행 실패: " + regResult[1] + "</span>\r\n";
                                }
                                else if(this.reList[i].action == "jsonObject") {

                                    if(regResult[1].trim() == "/re/info.json" || regResult[1].trim() == "/info/info.json") {
                                        this.deviceInfoJson = JSON.parse(regResult[2].trim());
                                        if(!this.isSameAcode && !this.isSameMacAddress) {
                                            if(typeof(this.deviceInfoJson.ac) != "undefined" && this.deviceInfoJson.ac != "") {
                                                this.getDidByAcode();
                                            }
                                        }
                                        else {
                                            this.deviceId = this.pageDevice.did;
                                        }
                                        this.deviceInfoJsonSSID = this.deviceInfoJson.ss;
                                        this.deviceInfoJsonPassword = this.deviceInfoJson.pw;

                                        /*
                                        if(this.isSameMacAddress && this.acode == "") {
                                            this.$parent.$parent.getAcode();
                                        }
                                        */
                                        
                                        if(!this.showSetWifiAction) {
                                            this.$bvModal.show("deviceInfoFloat");
                                        }

                                        if(this.showSetWifiAction && this.deviceInfoJson != null && this.isSameMacAddress) {
                                            this.sendCommand('print /wifi.json');
                                        }

                                        this.consoleContent += "\r\n<span class='text-info font-weight-bold'>기기 정보 Json 개체를 생성했습니다.</span>\r\n";
                                    }
                                    else if(regResult[1].trim() == "/config.json") {
                                        
                                        this.deviceConfigJson = JSON.parse(regResult[2].trim());
                                        this.consoleContent += "\r\n<span class='text-info font-weight-bold'>기기 설정 Json 개체를 생성했습니다.</span>\r\n";

                                        this.initDeviceConfigEditEnvironment();
                                    }
                                }
                                else if(this.reList[i].action == "jsonArray") {
                                    if(regResult[1].trim() == "/sensors.json") {
                                        this.deviceSensorsJson = JSON.parse(regResult[2].trim());
                                        this.consoleContent += "\r\n<span class='text-info font-weight-bold'>기기 센서 Json 개체를 생성했습니다.</span>\r\n";

                                        if(this.isSameMacAddress) {
                                           this.deviceSensorsJsonMerged = this.mergeArrayOfObjectsByKey(this.deviceSensorsJson, this.sensorsJsonSource, "na", "__", false);
                                        }
                                        else {
                                            this.deviceSensorsJsonMerged = this.mergeArrayOfObjectsByKey(this.deviceSensorsJson, [], "na", "__", false);
                                        }
                                    }
                                    else if(regResult[1].trim() == "/wifi.json") {
                                        this.deviceWifiJson = JSON.parse(regResult[2].trim());
                                        if(this.isSameMacAddress && typeof(this.pageDevice.wifi) != "undefined" && this.pageDevice.wifi.length != 0) {
                                            this.deviceWifiJsonMerged = this.mergeArrayOfObjectsByKey(this.deviceWifiJson, this.pageDevice.wifi, "s", "__", false);
                                        }
                                        else {
                                           this.deviceWifiJsonMerged = this.mergeArrayOfObjectsByKey(this.deviceWifiJson, [], "s", "__", false);
                                        }
                                        this.consoleContent += "\r\n<span class='text-info font-weight-bold'>기기 멀티 WiFi Json 개체를 생성했습니다.</span>\r\n";
                                    }
                                }

                                else if(this.reList[i].action == "connectWifiInsideDoLoop") {
                                    this.makeToast("success", "WiFi 연결됨", "센서 모드에서 WiFi가 연결되었습니다.", { autoHideDelay: 10000 });
                                    this.consoleContent += "\r\n<span class='text-info font-weight-bold'>센서 모드에서 WiFi가 연결되었습니다.</span>\r\n";
                                    if(this.deviceInfoJson != null) {
                                        this.deviceInfoJson.co = 1;
                                    }
                                }
                                else if(this.reList[i].action == "disconnectWifi") {
                                    this.makeToast("danger", "WiFi 연결이 끊김", "WiFi 연결이 끊어졌습니다.", { autoHideDelay: 10000 });
                                    this.consoleContent += "\r\n<span class='text-info font-weight-bold'>WiFi 연결이 끊어졌습니다.</span>\r\n";
                                    if(this.deviceInfoJson != null) {
                                        this.deviceInfoJson.co = 0;
                                    }
                                }
                            }
                        }
                    }

                    this.consoleContentTemp = "";
                    if(this.consoleAutoScroll) {
                        this.scrollToBottom(this.$refs.consoleContent);
                    }
                }
            },

            sendCommand: async function(command) {
                this.contentToWrite = command;
                await this.writeToSerial();
                this.sendCommandDisabled  = true;
                window.setTimeout(() => {
                    this.sendCommandDisabled = false;
                }, 3000);
            },

            writeToSerial: async function() {
                if(this.serialPort != null && this.serialPortWriter != null && this.contentToWrite != "") {
                    let toAdd = `\n<span class='text-danger'>serial write: <b>${this.contentToWrite}</b></span>\n\n`;
                    this.consoleContent += toAdd;
                    if(this.consoleAutoScroll) {
                        this.scrollToBottom(this.$refs.consoleContent);
                    }
                    this.contentWritten = this.contentToWrite;
                    await this.serialPortWriter.write(this.textEncoder.encode(this.contentToWrite));
                }
            },

            disconnectSerialPort: async function(showToastOnError=true) {
                if(this.serialPort != null) {
                    let hasError = false;
                    try {
                        if(this.serialPortReader != null) {
                            await this.serialPortReader.cancel();
                            this.serialPortReader.releaseLock();
                        }    
                        if(this.serialPortWriter != null) {
                            this.serialPortWriter.releaseLock();
                        }
                        await this.serialPort.close();
                    }
                    catch(error) {
                        let toAdd = "\n<span class='text-primary font-weight-bold'>에러: 연결을 해제할 수 없습니다. USB 선을 뽑았다가 다시 꽂아주세요.</span>\n\n";
                        this.consoleContent += toAdd;
                        if(this.consoleAutoScroll) {
                            this.scrollToBottom(this.$refs.consoleContent);
                        }
                        hasError = true; 
                        if(showToastOnError) {
                            this.makeToast("danger", "연결 해제 에러", "연결 해제중 에러가 발생했습니다. CH340 드라이버를 설치한 다음에 USB 케이블을 뽑았다가 다시 연결해보세요. 에러 내용: " + error, { autoHideDelay: 10000 });
                        }
                    }
                    this.serialPort = null;
                    if(hasError) {
                        this.connectedSerialInfo = "연결상태 이상. USB선을 다시 연결해주세요.";
                    }
                    else {
                        this.connectedSerialInfo = "연결 끊어짐.";
                        let toAdd = `\n<span class='text-primary'><b>${this.connectedSerialInfo}</b></span>\n\n`;
                        this.consoleContent += toAdd;
                        if(this.consoleAutoScroll) {
                            this.scrollToBottom(this.$refs.consoleContent);
                        }
                    }
                }    
            },

            connectSerialPort: async function() {

                try {

                    if(this.serialPort != null) {
                        this.serialPort = null;
                        this.connectedSerialInfo = "연결 끊어짐.";
                    }

                    if(this.useSerialPortFilter) {
                        const filters = [
                            { usbVendorId: 0x2341, usbProductId: 0x0043 }, //arduino
                            { usbVendorId: 0x2341, usbProductId: 0x0001 }, //arduino
                            { usbVendorId: 0x1a86, usbProductId: 0x7523 }, //CH340(esp8266, arduino, esp32)
                            { usbVendorId: 0x10c4, usbProductId: 0xea60 }, //cP210x(esp32, esp8266)
                            { usbVendorId: 0x1a86, usbProductId: 0x7522 },
                            { usbVendorId: 0x10c4, usbProductId: 0xea61 },
                            { usbVendorId: 0x10c4, usbProductId: 0xea63 }, 
                        ];
                        this.serialPort = await navigator.serial.requestPort({filters});
                    }
                    else {
                        this.serialPort = await navigator.serial.requestPort();
                    }

                    const serialInfo = this.serialPort.getInfo();
                    if("usbVendorId" in serialInfo && "usbProductId" in serialInfo) {
                        this.usbVendorId = serialInfo.usbVendorId;
                        this.usbProductId = serialInfo.usbProductId;
                        if(this.usbVendorId.toString(16) == "1a86") {
                            this.connectedSerialInfo = "CH340 드라이버, 아두이노/ESP8266, 팅커블 IoT 키트 V3.1 이하";
                            if(this.serialBaudRate == "") this.serialBaudRate = 74880;
                        }
                        else if(this.usbVendorId.toString(16) == "10c4") {
                            this.connectedSerialInfo = "CP210 드라이버, ESP32, 팅커블 IoT 키트 V5 이상";
                            if(this.serialBaudRate == "") this.serialBaudRate = 115200;
                        }
                        else {
                            this.connectedSerialInfo = "usbVendorId=0x" + this.usbVendorId + ", usbProductId=0x" + this.usbProductId;
                            if(this.serialBaudRate == "") this.serialBaudRate = 115200;
                        }
                    }
                    else {
                        this.connectedSerialInfo = "기기정보 없음";
                        if(this.serialBaudRate == "") this.serialBaudRate = 115200;
                    }

                    await this.serialPort.open({ baudRate: this.serialBaudRate });
                    this.connectedSerialInfo = "연결됨: " + this.connectedSerialInfo;

                    this.serialPortReader = this.serialPort.readable.getReader(); 
                    this.serialPortWriter = this.serialPort.writable.getWriter();

                    let toAdd = `\n<span class='text-primary'><b>${this.connectedSerialInfo}</b></span>\n\n`;
                    this.consoleContent += toAdd;
                    this.scrollToBottom(this.$refs.consoleContent);

                    this.sendCommand("info");

                    try {
                        while(this.serialPort.readable) {
                            const { value, done } = await this.serialPortReader.read();
                            if (done) {
                                break;
                            }
                            if (value) { 
                                this.readFromSerial(this.textDecoder.decode(value));
                            }
                        }
                    }
                    catch (error) {
                        let toAdd = `\n<span class='text-primary'><b>${error.toString()}</b></span>\n\n`;
                        this.consoleContent += toAdd;
                        if(this.consoleAutoScroll) {
                            this.scrollToBottom(this.$refs.consoleContent);
                        }
                        this.disconnectSerialPort();
                    }
                }
                catch(error) {
                    let toAdd = `\n<span class='text-primary'><b>${error.toString()}</b></span>\n\n`;
                    this.consoleContent += toAdd;
                    this.makeToast("danger", "기기 연결 에러", "기기 연결중 에러가 발생했습니다. USB 케이블을 뽑았다가 다시 연결해보세요. 에러 내용: " + error, { autoHideDelay: 10000 });
                    if(this.consoleAutoScroll) {
                        this.scrollToBottom(this.$refs.consoleContent);
                    }
                    this.disconnectSerialPort(false);
                }
            },
        },

        computed: {
            deviceNewSensors: function() {
                let result = [];
                if(this.deviceSensorsJsonMerged != null) {
                    Object.values(this.deviceSensorsJsonMerged).forEach(item => {
                        if(typeof(item.ty) != "undefined" && typeof(item.__ty) == "undefined") result.push(item.na);
                    })
                }
                return result;
            },

            sensorsJsonSource: function() {
                let result = [];
                for(let sensorName in this.pageDevice.sensors) {
                    let sensor = this.pageDevice.sensors[sensorName];
                    if(typeof(sensor.disabled) == "undefined" || sensor.disabled == false) {
                    let sensorObj = {
                        "na": sensor.name,
                        "va": []
                    }
                    if(typeof(sensor.type) == "undefined") {
                        sensorObj.ty = this.sensorType["CUSTOM"];
                    }
                    else {
                        sensorObj.ty = this.sensorType[sensor.type];
                    }

                    if(typeof(sensor.read) != "undefined" && sensor.read >= 0 && sensor.read != "") {
                        sensorObj.re = sensor.read*1
                    }
                    if(typeof(sensor.update) != "undefined" && sensor.update >= 0 && sensor.update != "") {
                        sensorObj.up = sensor.update*1
                    }

                    if(typeof(sensor.address) != "undefined" && sensor.address != "") {
                        sensorObj.ad = sensor.address
                    }
                    else if(typeof(sensor.pin) != "undefined" && sensor.pin != "") {
                        sensorObj.pi = sensor.pin
                    }
                    else {
                        if(typeof(sensor.rx) != "undefined" && sensor.rx != "") {
                        sensorObj.rx = sensor.rx
                        }
                        if(typeof(sensor.tx) != "undefined" && sensor.tx != "") {
                        sensorObj.tx = sensor.tx
                        }
                    }

                    if(sensor.values) {
                        sensor.values.forEach(value=>{
                        let valueObj = {
                            "na": value.name,
                        }
                        if(typeof(value.unit) != "undefined" && value.unit != "") {
                            valueObj.un = value.unit;
                        }
                        if(typeof(value.hide) != "undefined" && value.hide != false) {
                            valueObj.hi = 1;
                        }
                        if(typeof(value.hold) != "undefined" && value.hold != false) {
                            valueObj.ho = 1;
                        }
                        switch(value.type) {
                            case "number": valueObj.ty = this.valueType["FLOAT_VAL"]
                            break;
                            case "int": valueObj.ty = this.valueType["INT_VAL"]
                            break;
                            case "boolean": valueObj.ty = this.valueType["BOOL_VAL"]
                            break;
                            case "string": valueObj.ty = this.valueType["INT_VAL"]
                            break;
                            default: valueObj.ty = this.valueType[value.type]
                        }

                        if(typeof(value.max) == "number" && !isNaN(value.max*1)) {
                            valueObj.ma = value.max*1;
                        }
                        if(typeof(value.min) == "number" && !isNaN(value.min*1)) {
                            valueObj.mi = value.min*1
                        }
                        if(typeof(value.diff) == "number" && !isNaN(value.diff*1)) {
                            valueObj.di = value.diff;
                        }
                        sensorObj.va.push(valueObj)
                        })
                    }
                    result.push(sensorObj)
                    }
                }
                return result;
            },

            configStatusBinary: function() {
                let resultList = "".padStart(32, '0').split("");
                this.configStatusInputList.forEach(item => {
                    if(item.value == "1") {
                    this.$set(resultList, item.pos, "1");
                    }
                    else {
                    this.$set(resultList, item.pos, "0");
                    }
                });
                return resultList.join("");
            },

            configRebootBinary: function() {
                let resultList = "".padStart(32, '0').split("");
                if(this.configRebootUse) {
                    resultList[0] = "1";
                }
                this.configRebootWeekSelected.forEach(item => {
                    resultList[item] = "1";
                });
                this.configRebootHoursSelected.forEach(item => {
                    resultList[item] = "1";
                });
                return resultList.join("");
            },

            configSleepSaveBinary: function() {
                let resultList = "".padStart(32, '0').split("");
                if(this.configSleepSaveUse) {
                    resultList[0] = "1";
                }
                this.configSleepSaveWeekSelected.forEach(item => {
                    resultList[item] = "1";
                });
                this.configSleepSaveHoursSelected.forEach(item => {
                    resultList[item] = "1";
                });
                return resultList.join("");
            },

            configSleepUpdateBinary: function() {
                let resultList = "".padStart(32, '0').split("");
                if(this.configSleepUpdateUse) {
                    resultList[0] = "1";
                }
                this.configSleepUpdateWeekSelected.forEach(item => {
                    resultList[item] = "1";
                });
                this.configSleepUpdateHoursSelected.forEach(item => {
                    resultList[item] = "1";
                });
                return resultList.join("");
            },

            isSameMacAddress: function() {
                if(this.deviceInfoJson == null) return false;
                else if(typeof(this.pageDevice.macAddress) == "undefined") return false;
                else if(this.pageDevice.macAddress == "") return false;
                else if(this.deviceInfoJson.ma != this.pageDevice.macAddress) return false;
                else return true;
            },

            isSameAcode: function() {
                if(this.deviceInfoJson == null) return false;
                else if(typeof(this.pageDevice.acode) === "undefined") return false;
                else if(this.deviceInfoJson.ac == "") return false;
                else if(this.deviceInfoJson.ac != this.pageDevice.acode) return false;
                else return true;
            },

            isPageDeviceConfigExist: function() {
                if(typeof(this.pageDevice.config) == 'undefined' || this.pageDevice.config == null) return false;
                if(typeof(this.pageDevice.config.ve) == 'undefined') return false;
                return true;
            },

            deviceI2CSensors: function() {
                /*
#define TK_I2C_BH1750_ADDR 0x23
#define TK_I2C_INA219_ADDR 0x40
#define TK_I2C_SSD1306_ADDR 0x3C
#define TK_I2C_ADS1115_ADDR_0 0x48 // GND
#define TK_I2C_ADS1115_ADDR_1 0x49 // VCC
#define TK_I2C_ADS1115_ADDR_2 0x4a // SDA
#define TK_I2C_ADS1115_ADDR_3 0x4b // SCL
#define TK_I2C_BMP280_ADDR 0x76
#define TK_I2C_BME280_ADDR 0x76
#define TK_I2C_BME680_ADDR 0x77 // 0x76
#define TK_I2C_VEML6070_ADDR1 0x38
#define TK_I2C_VEML6070_ADDR2 0x39
#define TK_I2C_TCS34725_ADDR 0x29
#define TK_I2C_RTC_ADDR 0x68
// DS1307 and DS3231 temperature
// DS3231 = EEPROM 0x57, AT24C32 4K x 8-bit EEPROM nonvolatile memory
#define TK_I2C_RTC_EEPROM_ADDR 0x57
#define TK_I2C_CCS811_ADDR 0x5A //0x5B
                */

                let result = [];
                if(this.deviceInfoJson != null) {
                    this.deviceInfoJson.is.forEach(address => {
                        let converted = address.toString(16).toUpperCase();
                        switch(converted) {
                            case "23":
                                result.push("BH1750");
                                break;
                            case "40":
                                result.push("INA219");
                                break;
                            case "3C":
                                result.push("SSD1306");
                                break;
                            case "48":
                                result.push("ADS1115 [0]");
                                break;
                            case "49":
                                result.push("ADS1115 [1]");
                                break;
                            case "4A":
                                result.push("ADS1115 [2]");
                                break;
                            case "4B":
                                result.push("ADS1115 [3]");
                                break;
                            case "76":
                                result.push("BME280");
                                break;
                            case "77":
                                result.push("BME680");
                                break;
                            case "38":
                                result.push("VEML6070");
                                break;
                            case "39":
                                result.push("VEML6070");
                                break;
                            case "29":
                                result.push("TCS34725");
                                break;
                            case "68":
                                result.push("RTC");
                                break;
                            case "57":
                                result.push("EEPROM");
                                break;
                            case "5B":
                                result.push("CCS811");
                                break;
                            default:
                                result.push("0x" + converted);    
                        }
                    });
                }
                return result.join(", ");
            },
            deviceShowMode: function() {
                let result = "";
                if(this.deviceInfoJson != null) {
                    if(this.deviceInfoJson.sh == 2) {
                        result = "SHOW_SETUP";
                    }
                    else if(this.deviceInfoJson.sh == 3) {
                        result = "SHOW_SENSORS";
                    }
                    else if(this.deviceInfoJson.sh == 4) {
                        result = "SHOW_LOGS";
                    }
                    else if(this.deviceInfoJson.sh == 5) {
                        result = "SHOW_WPS";
                    }
                    else if(this.deviceInfoJson.sh == 6) {
                        result = "SHOW_OTA";
                    }
                    else if(this.deviceInfoJson.sh == 7) {
                        result = "SHOW_PARAM";
                    }
                    else if(this.deviceInfoJson.sh == 8) {
                        result = "SHOW_CONNECTING";
                    }
                    else {
                        result = "SHOW_NONE";
                    }
                }
                return result;
            }
        }
    }
</script>